"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Plurally
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgsApiFactory = exports.OrgsApiFp = exports.OrgsApiAxiosParamCreator = exports.NotifsApi = exports.NotifsApiFactory = exports.NotifsApiFp = exports.NotifsApiAxiosParamCreator = exports.MetricsApi = exports.MetricsApiFactory = exports.MetricsApiFp = exports.MetricsApiAxiosParamCreator = exports.MetaApi = exports.MetaApiFactory = exports.MetaApiFp = exports.MetaApiAxiosParamCreator = exports.HealthApi = exports.HealthApiFactory = exports.HealthApiFp = exports.HealthApiAxiosParamCreator = exports.FlowsApi = exports.FlowsApiFactory = exports.FlowsApiFp = exports.FlowsApiAxiosParamCreator = exports.DummyApi = exports.DummyApiFactory = exports.DummyApiFp = exports.DummyApiAxiosParamCreator = exports.ContactApi = exports.ContactApiFactory = exports.ContactApiFp = exports.ContactApiAxiosParamCreator = exports.CasesApi = exports.CasesApiFactory = exports.CasesApiFp = exports.CasesApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.UserLayout = exports.SalesforceObjectType = exports.OutputType = exports.NotifType = exports.JobStatus = exports.FormEntryType = exports.CorrectionReason = void 0;
exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiAxiosParamCreator = exports.TemplatesApi = exports.TemplatesApiFactory = exports.TemplatesApiFp = exports.TemplatesApiAxiosParamCreator = exports.SubscriptionsApi = exports.SubscriptionsApiFactory = exports.SubscriptionsApiFp = exports.SubscriptionsApiAxiosParamCreator = exports.StripeApi = exports.StripeApiFactory = exports.StripeApiFp = exports.StripeApiAxiosParamCreator = exports.SentryApi = exports.SentryApiFactory = exports.SentryApiFp = exports.SentryApiAxiosParamCreator = exports.RunsApi = exports.RunsApiFactory = exports.RunsApiFp = exports.RunsApiAxiosParamCreator = exports.PingApi = exports.PingApiFactory = exports.PingApiFp = exports.PingApiAxiosParamCreator = exports.OverridesApi = exports.OverridesApiFactory = exports.OverridesApiFp = exports.OverridesApiAxiosParamCreator = exports.OrgsApi = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.CorrectionReason = {
    VocabMissing: '_correction:vocab_missing',
    BadUnderstanding: '_correction:bad_understanding',
    Other: '_correction:other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FormEntryType = {
    ShortText: 'short_text',
    Text: 'text',
    Email: 'email',
    Number: 'number',
    TrueFalse: 'true/false',
    AudioFile: 'audio file',
    AudioRecord: 'audio record',
    Image: 'image',
    Select: 'select'
};
/**
 * The Status of Job within its lifecycle at any given time.
 * @export
 * @enum {string}
 */
exports.JobStatus = {
    Queued: 'queued',
    Finished: 'finished',
    Failed: 'failed',
    Started: 'started',
    Deferred: 'deferred',
    Scheduled: 'scheduled',
    Stopped: 'stopped',
    Canceled: 'canceled'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.NotifType = {
    InstaDmEscalation: 'insta_dm_escalation',
    FlowFailed: 'flow_failed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OutputType = {
    Text: 'text',
    Html: 'html',
    HtmlToPdf: 'html_to_pdf',
    CrmActions: 'crm_actions',
    Table: 'table',
    Markdown: 'markdown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SalesforceObjectType = {
    Contact: 'Contact',
    Account: 'Account',
    Lead: 'Lead',
    Event: 'Event',
    Opportunity: 'Opportunity',
    Task: 'Task',
    PoulaillerC: 'Poulailler__c',
    AssociatedLocation: 'AssociatedLocation',
    EventRelation: 'EventRelation'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UserLayout = {
    Default: 'default',
    Cases: 'cases'
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
var AdminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Checkout Admin
         * @param {string} userId
         * @param {string} plan
         * @param {string} successUrl
         * @param {string} cancelUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutAdminApiV1AdminSubscriptionsCheckoutGet: function (userId_1, plan_1, successUrl_1, cancelUrl_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userId_1, plan_1, successUrl_1, cancelUrl_1], args_1, true), void 0, function (userId, plan, successUrl, cancelUrl, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('checkoutAdminApiV1AdminSubscriptionsCheckoutGet', 'userId', userId);
                    // verify required parameter 'plan' is not null or undefined
                    (0, common_1.assertParamExists)('checkoutAdminApiV1AdminSubscriptionsCheckoutGet', 'plan', plan);
                    // verify required parameter 'successUrl' is not null or undefined
                    (0, common_1.assertParamExists)('checkoutAdminApiV1AdminSubscriptionsCheckoutGet', 'successUrl', successUrl);
                    // verify required parameter 'cancelUrl' is not null or undefined
                    (0, common_1.assertParamExists)('checkoutAdminApiV1AdminSubscriptionsCheckoutGet', 'cancelUrl', cancelUrl);
                    localVarPath = "/api/v1/admin/subscriptions/checkout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (userId !== undefined) {
                        localVarQueryParameter['user_id'] = userId;
                    }
                    if (plan !== undefined) {
                        localVarQueryParameter['plan'] = plan;
                    }
                    if (successUrl !== undefined) {
                        localVarQueryParameter['success_url'] = successUrl;
                    }
                    if (cancelUrl !== undefined) {
                        localVarQueryParameter['cancel_url'] = cancelUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create new case.
         * @summary Create Case Admin
         * @param {CaseCreateAdmin} caseCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseAdminApiV1AdminCasesPost: function (caseCreateAdmin_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([caseCreateAdmin_1], args_1, true), void 0, function (caseCreateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'caseCreateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('createCaseAdminApiV1AdminCasesPost', 'caseCreateAdmin', caseCreateAdmin);
                    localVarPath = "/api/v1/admin/cases";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(caseCreateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create flow admin.
         * @summary Create Flow Admin
         * @param {FlowCreateAdmin} flowCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowAdminApiV1AdminFlowsPost: function (flowCreateAdmin_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowCreateAdmin_1], args_1, true), void 0, function (flowCreateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowCreateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('createFlowAdminApiV1AdminFlowsPost', 'flowCreateAdmin', flowCreateAdmin);
                    localVarPath = "/api/v1/admin/flows";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(flowCreateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a notif.
         * @summary Create Notif Admin
         * @param {string} userId
         * @param {Notif} notif
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotifAdminApiV1AdminNotifsPost: function (userId_1, notif_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userId_1, notif_1], args_1, true), void 0, function (userId, notif, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('createNotifAdminApiV1AdminNotifsPost', 'userId', userId);
                    // verify required parameter 'notif' is not null or undefined
                    (0, common_1.assertParamExists)('createNotifAdminApiV1AdminNotifsPost', 'notif', notif);
                    localVarPath = "/api/v1/admin/notifs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (userId !== undefined) {
                        localVarQueryParameter['user_id'] = userId;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notif, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create new org.
         * @summary Create Org Admin
         * @param {OrgCreateAdmin} orgCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgAdminApiV1AdminOrgsPost: function (orgCreateAdmin_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([orgCreateAdmin_1], args_1, true), void 0, function (orgCreateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'orgCreateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('createOrgAdminApiV1AdminOrgsPost', 'orgCreateAdmin', orgCreateAdmin);
                    localVarPath = "/api/v1/admin/orgs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgCreateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create template from flow admin.
         * @summary Create Template From Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost', 'flowId', flowId);
                    localVarPath = "/api/v1/admin/flows/{flow_id}/template"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a user.
         * @summary Create User Admin
         * @param {UserCreateAdmin} userCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAdminApiV1AdminUserPost: function (userCreateAdmin_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userCreateAdmin_1], args_1, true), void 0, function (userCreateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userCreateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('createUserAdminApiV1AdminUserPost', 'userCreateAdmin', userCreateAdmin);
                    localVarPath = "/api/v1/admin/user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCreateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Debug Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugRunApiV1AdminRunsRunIdDebugGet: function (runId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1], args_1, true), void 0, function (runId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'runId' is not null or undefined
                    (0, common_1.assertParamExists)('debugRunApiV1AdminRunsRunIdDebugGet', 'runId', runId);
                    localVarPath = "/api/v1/admin/runs/{run_id}/debug"
                        .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a case.
         * @summary Delete Case Admin
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCaseAdminApiV1AdminCasesIdDelete: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCaseAdminApiV1AdminCasesIdDelete', 'id', id);
                    localVarPath = "/api/v1/admin/cases/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowAdminApiV1AdminFlowsFlowIdDelete: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFlowAdminApiV1AdminFlowsFlowIdDelete', 'flowId', flowId);
                    localVarPath = "/api/v1/admin/flows/{flow_id}"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete Run Admin
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRunAdminApiV1AdminRunsRunIdDelete: function (runId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1], args_1, true), void 0, function (runId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'runId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteRunAdminApiV1AdminRunsRunIdDelete', 'runId', runId);
                    localVarPath = "/api/v1/admin/runs/{run_id}"
                        .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete template.
         * @summary Delete Template Admin
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete: function (templateId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1], args_1, true), void 0, function (templateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'templateId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete', 'templateId', templateId);
                    localVarPath = "/api/v1/admin/templates/{template_id}"
                        .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a user.
         * @summary Delete User Admin
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAdminApiV1AdminUserUserIdDelete: function (userId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userId_1], args_1, true), void 0, function (userId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteUserAdminApiV1AdminUserUserIdDelete', 'userId', userId);
                    localVarPath = "/api/v1/admin/user/{user_id}"
                        .replace("{".concat("user_id", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Escalate Instagram DM.
         * @summary Escalate Admin
         * @param {string} ownerId
         * @param {string} recipientId
         * @param {string} senderId
         * @param {string} senderUsername
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost: function (ownerId_1, recipientId_1, senderId_1, senderUsername_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ownerId_1, recipientId_1, senderId_1, senderUsername_1], args_1, true), void 0, function (ownerId, recipientId, senderId, senderUsername, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'ownerId' is not null or undefined
                    (0, common_1.assertParamExists)('escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost', 'ownerId', ownerId);
                    // verify required parameter 'recipientId' is not null or undefined
                    (0, common_1.assertParamExists)('escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost', 'recipientId', recipientId);
                    // verify required parameter 'senderId' is not null or undefined
                    (0, common_1.assertParamExists)('escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost', 'senderId', senderId);
                    // verify required parameter 'senderUsername' is not null or undefined
                    (0, common_1.assertParamExists)('escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost', 'senderUsername', senderUsername);
                    localVarPath = "/api/v1/admin/meta/instagram/new-dms/escalation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ownerId !== undefined) {
                        localVarQueryParameter['owner_id'] = ownerId;
                    }
                    if (recipientId !== undefined) {
                        localVarQueryParameter['recipient_id'] = recipientId;
                    }
                    if (senderId !== undefined) {
                        localVarQueryParameter['sender_id'] = senderId;
                    }
                    if (senderUsername !== undefined) {
                        localVarQueryParameter['sender_username'] = senderUsername;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get Flow Json
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowJsonApiV1AdminRunsRunIdFlowJsonGet: function (runId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1], args_1, true), void 0, function (runId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'runId' is not null or undefined
                    (0, common_1.assertParamExists)('getFlowJsonApiV1AdminRunsRunIdFlowJsonGet', 'runId', runId);
                    localVarPath = "/api/v1/admin/runs/{run_id}/flow_json"
                        .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthApiV1AdminHealthGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingApiV1AdminPingGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/ping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get cases.
         * @summary Read Cases Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCasesAdminApiV1AdminCasesGet: function (skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([skip_1, limit_1], args_1, true), void 0, function (skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/cases";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowAdminApiV1AdminFlowsFlowIdGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('readFlowAdminApiV1AdminFlowsFlowIdGet', 'flowId', flowId);
                    localVarPath = "/api/v1/admin/flows/{flow_id}"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Flow Settings Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet', 'flowId', flowId);
                    localVarPath = "/api/v1/admin/flows/{flow_id}/settings"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Flows Admin
         * @param {string} ownerId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowsAdminApiV1AdminFlowsGet: function (ownerId_1, skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ownerId_1, skip_1, limit_1], args_1, true), void 0, function (ownerId, skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'ownerId' is not null or undefined
                    (0, common_1.assertParamExists)('readFlowsAdminApiV1AdminFlowsGet', 'ownerId', ownerId);
                    localVarPath = "/api/v1/admin/flows";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ownerId !== undefined) {
                        localVarQueryParameter['owner_id'] = ownerId;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get issues.
         * @summary Read Issues Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet', 'flowId', flowId);
                    localVarPath = "/api/v1/admin/flows/{flow_id}/issues"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get orgs.
         * @summary Read Orgs Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOrgsAdminApiV1AdminOrgsGet: function (skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([skip_1, limit_1], args_1, true), void 0, function (skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/orgs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Run Admin
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunAdminApiV1AdminRunsRunIdGet: function (runId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1], args_1, true), void 0, function (runId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'runId' is not null or undefined
                    (0, common_1.assertParamExists)('readRunAdminApiV1AdminRunsRunIdGet', 'runId', runId);
                    localVarPath = "/api/v1/admin/runs/{run_id}"
                        .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Runs Admin
         * @param {string | null} [ownerId]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunsAdminApiV1AdminRunsGet: function (ownerId_1, skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ownerId_1, skip_1, limit_1], args_1, true), void 0, function (ownerId, skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/runs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ownerId !== undefined) {
                        localVarQueryParameter['owner_id'] = ownerId;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Salesforce Entities Admin
         * @param {string} ownerId
         * @param {string} instanceUrl
         * @param {SalesforceObjectType} sObjectType
         * @param {string} cols
         * @param {string} query
         * @param {string | null} [recordType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet: function (ownerId_1, instanceUrl_1, sObjectType_1, cols_1, query_1, recordType_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ownerId_1, instanceUrl_1, sObjectType_1, cols_1, query_1, recordType_1], args_1, true), void 0, function (ownerId, instanceUrl, sObjectType, cols, query, recordType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'ownerId' is not null or undefined
                    (0, common_1.assertParamExists)('readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet', 'ownerId', ownerId);
                    // verify required parameter 'instanceUrl' is not null or undefined
                    (0, common_1.assertParamExists)('readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet', 'instanceUrl', instanceUrl);
                    // verify required parameter 'sObjectType' is not null or undefined
                    (0, common_1.assertParamExists)('readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet', 'sObjectType', sObjectType);
                    // verify required parameter 'cols' is not null or undefined
                    (0, common_1.assertParamExists)('readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet', 'cols', cols);
                    // verify required parameter 'query' is not null or undefined
                    (0, common_1.assertParamExists)('readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet', 'query', query);
                    localVarPath = "/api/v1/admin/overrides/salesforce/query";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ownerId !== undefined) {
                        localVarQueryParameter['owner_id'] = ownerId;
                    }
                    if (instanceUrl !== undefined) {
                        localVarQueryParameter['instance_url'] = instanceUrl;
                    }
                    if (sObjectType !== undefined) {
                        localVarQueryParameter['s_object_type'] = sObjectType;
                    }
                    if (cols !== undefined) {
                        localVarQueryParameter['cols'] = cols;
                    }
                    if (query !== undefined) {
                        localVarQueryParameter['query'] = query;
                    }
                    if (recordType !== undefined) {
                        localVarQueryParameter['record_type'] = recordType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Subscription Admin
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet: function (subscriptionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([subscriptionId_1], args_1, true), void 0, function (subscriptionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'subscriptionId' is not null or undefined
                    (0, common_1.assertParamExists)('readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet', 'subscriptionId', subscriptionId);
                    localVarPath = "/api/v1/admin/subscriptions/{subscription_id}"
                        .replace("{".concat("subscription_id", "}"), encodeURIComponent(String(subscriptionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Subscriptions Admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionsAdminApiV1AdminSubscriptionsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/subscriptions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get current user\'s templates.
         * @summary Read Templates Admin
         * @param {string} [ownerId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplatesAdminApiV1AdminTemplatesGet: function (ownerId_1, limit_1, skip_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ownerId_1, limit_1, skip_1], args_1, true), void 0, function (ownerId, limit, skip, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/templates";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ownerId !== undefined) {
                        localVarQueryParameter['owner_id'] = ownerId;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all users.
         * @summary Read Users Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string | null} [orgId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUsersAdminApiV1AdminUserGet: function (skip_1, limit_1, orgId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([skip_1, limit_1, orgId_1], args_1, true), void 0, function (skip, limit, orgId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (orgId !== undefined) {
                        localVarQueryParameter['org_id'] = orgId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Run flow admin.
         * @summary Run Flow Admin
         * @param {string} flowId
         * @param {Array<string>} [envVarsOverride]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runFlowAdminApiV1AdminFlowsFlowIdStartPost: function (flowId_1, envVarsOverride_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, envVarsOverride_1], args_1, true), void 0, function (flowId, envVarsOverride, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('runFlowAdminApiV1AdminFlowsFlowIdStartPost', 'flowId', flowId);
                    localVarPath = "/api/v1/admin/flows/{flow_id}/start"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (envVarsOverride) {
                        localVarFormParams.set('env_vars_override', envVarsOverride.join(base_1.COLLECTION_FORMATS.csv));
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Stops running flow.
         * @summary Stop Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopFlowAdminApiV1AdminFlowsFlowIdStopDelete: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('stopFlowAdminApiV1AdminFlowsFlowIdStopDelete', 'flowId', flowId);
                    localVarPath = "/api/v1/admin/flows/{flow_id}/stop"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Test Sentry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSentryApiV1AdminSentryGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/sentry";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update an case.
         * @summary Update Case Admin
         * @param {string} id
         * @param {CaseUpdateAdmin} caseUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAdminApiV1AdminCasesIdPut: function (id_1, caseUpdateAdmin_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, caseUpdateAdmin_1], args_1, true), void 0, function (id, caseUpdateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateCaseAdminApiV1AdminCasesIdPut', 'id', id);
                    // verify required parameter 'caseUpdateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('updateCaseAdminApiV1AdminCasesIdPut', 'caseUpdateAdmin', caseUpdateAdmin);
                    localVarPath = "/api/v1/admin/cases/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(caseUpdateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update flow admin.
         * @summary Update Flow Admin
         * @param {string} flowId
         * @param {FlowUpdateAdmin} flowUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowAdminApiV1AdminFlowsFlowIdPut: function (flowId_1, flowUpdateAdmin_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, flowUpdateAdmin_1], args_1, true), void 0, function (flowId, flowUpdateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('updateFlowAdminApiV1AdminFlowsFlowIdPut', 'flowId', flowId);
                    // verify required parameter 'flowUpdateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('updateFlowAdminApiV1AdminFlowsFlowIdPut', 'flowUpdateAdmin', flowUpdateAdmin);
                    localVarPath = "/api/v1/admin/flows/{flow_id}"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(flowUpdateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update an org.
         * @summary Update Org Admin
         * @param {string} id
         * @param {OrgUpdateAdmin} orgUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgAdminApiV1AdminOrgsIdPut: function (id_1, orgUpdateAdmin_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, orgUpdateAdmin_1], args_1, true), void 0, function (id, orgUpdateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateOrgAdminApiV1AdminOrgsIdPut', 'id', id);
                    // verify required parameter 'orgUpdateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('updateOrgAdminApiV1AdminOrgsIdPut', 'orgUpdateAdmin', orgUpdateAdmin);
                    localVarPath = "/api/v1/admin/orgs/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgUpdateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update template.
         * @summary Update Template Admin
         * @param {string} templateId
         * @param {TemplateUpdateAdmin} templateUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateAdminApiV1AdminTemplatesTemplateIdPut: function (templateId_1, templateUpdateAdmin_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1, templateUpdateAdmin_1], args_1, true), void 0, function (templateId, templateUpdateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'templateId' is not null or undefined
                    (0, common_1.assertParamExists)('updateTemplateAdminApiV1AdminTemplatesTemplateIdPut', 'templateId', templateId);
                    // verify required parameter 'templateUpdateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('updateTemplateAdminApiV1AdminTemplatesTemplateIdPut', 'templateUpdateAdmin', templateUpdateAdmin);
                    localVarPath = "/api/v1/admin/templates/{template_id}"
                        .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(templateUpdateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update a user admin
         * @summary Update User Admin
         * @param {string} userId
         * @param {UserUpdateAdmin} userUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAdminApiV1AdminUserUserIdPut: function (userId_1, userUpdateAdmin_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userId_1, userUpdateAdmin_1], args_1, true), void 0, function (userId, userUpdateAdmin, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('updateUserAdminApiV1AdminUserUserIdPut', 'userId', userId);
                    // verify required parameter 'userUpdateAdmin' is not null or undefined
                    (0, common_1.assertParamExists)('updateUserAdminApiV1AdminUserUserIdPut', 'userUpdateAdmin', userUpdateAdmin);
                    localVarPath = "/api/v1/admin/user/{user_id}"
                        .replace("{".concat("user_id", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userUpdateAdmin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
var AdminApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Checkout Admin
         * @param {string} userId
         * @param {string} plan
         * @param {string} successUrl
         * @param {string} cancelUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutAdminApiV1AdminSubscriptionsCheckoutGet: function (userId, plan, successUrl, cancelUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkoutAdminApiV1AdminSubscriptionsCheckoutGet(userId, plan, successUrl, cancelUrl, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.checkoutAdminApiV1AdminSubscriptionsCheckoutGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create new case.
         * @summary Create Case Admin
         * @param {CaseCreateAdmin} caseCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseAdminApiV1AdminCasesPost: function (caseCreateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCaseAdminApiV1AdminCasesPost(caseCreateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.createCaseAdminApiV1AdminCasesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create flow admin.
         * @summary Create Flow Admin
         * @param {FlowCreateAdmin} flowCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowAdminApiV1AdminFlowsPost: function (flowCreateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFlowAdminApiV1AdminFlowsPost(flowCreateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.createFlowAdminApiV1AdminFlowsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a notif.
         * @summary Create Notif Admin
         * @param {string} userId
         * @param {Notif} notif
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotifAdminApiV1AdminNotifsPost: function (userId, notif, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNotifAdminApiV1AdminNotifsPost(userId, notif, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.createNotifAdminApiV1AdminNotifsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create new org.
         * @summary Create Org Admin
         * @param {OrgCreateAdmin} orgCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgAdminApiV1AdminOrgsPost: function (orgCreateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOrgAdminApiV1AdminOrgsPost(orgCreateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.createOrgAdminApiV1AdminOrgsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create template from flow admin.
         * @summary Create Template From Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a user.
         * @summary Create User Admin
         * @param {UserCreateAdmin} userCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAdminApiV1AdminUserPost: function (userCreateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createUserAdminApiV1AdminUserPost(userCreateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.createUserAdminApiV1AdminUserPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Debug Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugRunApiV1AdminRunsRunIdDebugGet: function (runId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.debugRunApiV1AdminRunsRunIdDebugGet(runId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.debugRunApiV1AdminRunsRunIdDebugGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a case.
         * @summary Delete Case Admin
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCaseAdminApiV1AdminCasesIdDelete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCaseAdminApiV1AdminCasesIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.deleteCaseAdminApiV1AdminCasesIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowAdminApiV1AdminFlowsFlowIdDelete: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFlowAdminApiV1AdminFlowsFlowIdDelete(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.deleteFlowAdminApiV1AdminFlowsFlowIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Run Admin
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRunAdminApiV1AdminRunsRunIdDelete: function (runId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRunAdminApiV1AdminRunsRunIdDelete(runId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.deleteRunAdminApiV1AdminRunsRunIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete template.
         * @summary Delete Template Admin
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a user.
         * @summary Delete User Admin
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAdminApiV1AdminUserUserIdDelete: function (userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteUserAdminApiV1AdminUserUserIdDelete(userId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.deleteUserAdminApiV1AdminUserUserIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Escalate Instagram DM.
         * @summary Escalate Admin
         * @param {string} ownerId
         * @param {string} recipientId
         * @param {string} senderId
         * @param {string} senderUsername
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost: function (ownerId, recipientId, senderId, senderUsername, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost(ownerId, recipientId, senderId, senderUsername, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Flow Json
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowJsonApiV1AdminRunsRunIdFlowJsonGet: function (runId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFlowJsonApiV1AdminRunsRunIdFlowJsonGet(runId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.getFlowJsonApiV1AdminRunsRunIdFlowJsonGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthApiV1AdminHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthApiV1AdminHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.healthApiV1AdminHealthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingApiV1AdminPingGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pingApiV1AdminPingGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.pingApiV1AdminPingGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get cases.
         * @summary Read Cases Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCasesAdminApiV1AdminCasesGet: function (skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readCasesAdminApiV1AdminCasesGet(skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readCasesAdminApiV1AdminCasesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowAdminApiV1AdminFlowsFlowIdGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readFlowAdminApiV1AdminFlowsFlowIdGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readFlowAdminApiV1AdminFlowsFlowIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Flow Settings Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Flows Admin
         * @param {string} ownerId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowsAdminApiV1AdminFlowsGet: function (ownerId, skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readFlowsAdminApiV1AdminFlowsGet(ownerId, skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readFlowsAdminApiV1AdminFlowsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get issues.
         * @summary Read Issues Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get orgs.
         * @summary Read Orgs Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOrgsAdminApiV1AdminOrgsGet: function (skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readOrgsAdminApiV1AdminOrgsGet(skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readOrgsAdminApiV1AdminOrgsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Run Admin
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunAdminApiV1AdminRunsRunIdGet: function (runId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readRunAdminApiV1AdminRunsRunIdGet(runId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readRunAdminApiV1AdminRunsRunIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Runs Admin
         * @param {string | null} [ownerId]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunsAdminApiV1AdminRunsGet: function (ownerId, skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readRunsAdminApiV1AdminRunsGet(ownerId, skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readRunsAdminApiV1AdminRunsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Salesforce Entities Admin
         * @param {string} ownerId
         * @param {string} instanceUrl
         * @param {SalesforceObjectType} sObjectType
         * @param {string} cols
         * @param {string} query
         * @param {string | null} [recordType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet: function (ownerId, instanceUrl, sObjectType, cols, query, recordType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet(ownerId, instanceUrl, sObjectType, cols, query, recordType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Subscription Admin
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet: function (subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet(subscriptionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Subscriptions Admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionsAdminApiV1AdminSubscriptionsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readSubscriptionsAdminApiV1AdminSubscriptionsGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readSubscriptionsAdminApiV1AdminSubscriptionsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user\'s templates.
         * @summary Read Templates Admin
         * @param {string} [ownerId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplatesAdminApiV1AdminTemplatesGet: function (ownerId, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readTemplatesAdminApiV1AdminTemplatesGet(ownerId, limit, skip, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readTemplatesAdminApiV1AdminTemplatesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all users.
         * @summary Read Users Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string | null} [orgId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUsersAdminApiV1AdminUserGet: function (skip, limit, orgId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readUsersAdminApiV1AdminUserGet(skip, limit, orgId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.readUsersAdminApiV1AdminUserGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Run flow admin.
         * @summary Run Flow Admin
         * @param {string} flowId
         * @param {Array<string>} [envVarsOverride]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runFlowAdminApiV1AdminFlowsFlowIdStartPost: function (flowId, envVarsOverride, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.runFlowAdminApiV1AdminFlowsFlowIdStartPost(flowId, envVarsOverride, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.runFlowAdminApiV1AdminFlowsFlowIdStartPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Stops running flow.
         * @summary Stop Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopFlowAdminApiV1AdminFlowsFlowIdStopDelete: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stopFlowAdminApiV1AdminFlowsFlowIdStopDelete(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.stopFlowAdminApiV1AdminFlowsFlowIdStopDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Test Sentry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSentryApiV1AdminSentryGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.testSentryApiV1AdminSentryGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.testSentryApiV1AdminSentryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update an case.
         * @summary Update Case Admin
         * @param {string} id
         * @param {CaseUpdateAdmin} caseUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAdminApiV1AdminCasesIdPut: function (id, caseUpdateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCaseAdminApiV1AdminCasesIdPut(id, caseUpdateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.updateCaseAdminApiV1AdminCasesIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update flow admin.
         * @summary Update Flow Admin
         * @param {string} flowId
         * @param {FlowUpdateAdmin} flowUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowAdminApiV1AdminFlowsFlowIdPut: function (flowId, flowUpdateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFlowAdminApiV1AdminFlowsFlowIdPut(flowId, flowUpdateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.updateFlowAdminApiV1AdminFlowsFlowIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update an org.
         * @summary Update Org Admin
         * @param {string} id
         * @param {OrgUpdateAdmin} orgUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgAdminApiV1AdminOrgsIdPut: function (id, orgUpdateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOrgAdminApiV1AdminOrgsIdPut(id, orgUpdateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.updateOrgAdminApiV1AdminOrgsIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update template.
         * @summary Update Template Admin
         * @param {string} templateId
         * @param {TemplateUpdateAdmin} templateUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateAdminApiV1AdminTemplatesTemplateIdPut: function (templateId, templateUpdateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTemplateAdminApiV1AdminTemplatesTemplateIdPut(templateId, templateUpdateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.updateTemplateAdminApiV1AdminTemplatesTemplateIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a user admin
         * @summary Update User Admin
         * @param {string} userId
         * @param {UserUpdateAdmin} userUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAdminApiV1AdminUserUserIdPut: function (userId, userUpdateAdmin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUserAdminApiV1AdminUserUserIdPut(userId, userUpdateAdmin, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.updateUserAdminApiV1AdminUserUserIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
var AdminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         *
         * @summary Checkout Admin
         * @param {string} userId
         * @param {string} plan
         * @param {string} successUrl
         * @param {string} cancelUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutAdminApiV1AdminSubscriptionsCheckoutGet: function (userId, plan, successUrl, cancelUrl, options) {
            return localVarFp.checkoutAdminApiV1AdminSubscriptionsCheckoutGet(userId, plan, successUrl, cancelUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new case.
         * @summary Create Case Admin
         * @param {CaseCreateAdmin} caseCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseAdminApiV1AdminCasesPost: function (caseCreateAdmin, options) {
            return localVarFp.createCaseAdminApiV1AdminCasesPost(caseCreateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create flow admin.
         * @summary Create Flow Admin
         * @param {FlowCreateAdmin} flowCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowAdminApiV1AdminFlowsPost: function (flowCreateAdmin, options) {
            return localVarFp.createFlowAdminApiV1AdminFlowsPost(flowCreateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a notif.
         * @summary Create Notif Admin
         * @param {string} userId
         * @param {Notif} notif
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotifAdminApiV1AdminNotifsPost: function (userId, notif, options) {
            return localVarFp.createNotifAdminApiV1AdminNotifsPost(userId, notif, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new org.
         * @summary Create Org Admin
         * @param {OrgCreateAdmin} orgCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgAdminApiV1AdminOrgsPost: function (orgCreateAdmin, options) {
            return localVarFp.createOrgAdminApiV1AdminOrgsPost(orgCreateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create template from flow admin.
         * @summary Create Template From Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost: function (flowId, options) {
            return localVarFp.createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a user.
         * @summary Create User Admin
         * @param {UserCreateAdmin} userCreateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAdminApiV1AdminUserPost: function (userCreateAdmin, options) {
            return localVarFp.createUserAdminApiV1AdminUserPost(userCreateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Debug Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugRunApiV1AdminRunsRunIdDebugGet: function (runId, options) {
            return localVarFp.debugRunApiV1AdminRunsRunIdDebugGet(runId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a case.
         * @summary Delete Case Admin
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCaseAdminApiV1AdminCasesIdDelete: function (id, options) {
            return localVarFp.deleteCaseAdminApiV1AdminCasesIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowAdminApiV1AdminFlowsFlowIdDelete: function (flowId, options) {
            return localVarFp.deleteFlowAdminApiV1AdminFlowsFlowIdDelete(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Run Admin
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRunAdminApiV1AdminRunsRunIdDelete: function (runId, options) {
            return localVarFp.deleteRunAdminApiV1AdminRunsRunIdDelete(runId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete template.
         * @summary Delete Template Admin
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete: function (templateId, options) {
            return localVarFp.deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete(templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a user.
         * @summary Delete User Admin
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAdminApiV1AdminUserUserIdDelete: function (userId, options) {
            return localVarFp.deleteUserAdminApiV1AdminUserUserIdDelete(userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Escalate Instagram DM.
         * @summary Escalate Admin
         * @param {string} ownerId
         * @param {string} recipientId
         * @param {string} senderId
         * @param {string} senderUsername
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost: function (ownerId, recipientId, senderId, senderUsername, options) {
            return localVarFp.escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost(ownerId, recipientId, senderId, senderUsername, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Flow Json
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowJsonApiV1AdminRunsRunIdFlowJsonGet: function (runId, options) {
            return localVarFp.getFlowJsonApiV1AdminRunsRunIdFlowJsonGet(runId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthApiV1AdminHealthGet: function (options) {
            return localVarFp.healthApiV1AdminHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingApiV1AdminPingGet: function (options) {
            return localVarFp.pingApiV1AdminPingGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get cases.
         * @summary Read Cases Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCasesAdminApiV1AdminCasesGet: function (skip, limit, options) {
            return localVarFp.readCasesAdminApiV1AdminCasesGet(skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowAdminApiV1AdminFlowsFlowIdGet: function (flowId, options) {
            return localVarFp.readFlowAdminApiV1AdminFlowsFlowIdGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Flow Settings Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet: function (flowId, options) {
            return localVarFp.readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Flows Admin
         * @param {string} ownerId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowsAdminApiV1AdminFlowsGet: function (ownerId, skip, limit, options) {
            return localVarFp.readFlowsAdminApiV1AdminFlowsGet(ownerId, skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get issues.
         * @summary Read Issues Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet: function (flowId, options) {
            return localVarFp.readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get orgs.
         * @summary Read Orgs Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOrgsAdminApiV1AdminOrgsGet: function (skip, limit, options) {
            return localVarFp.readOrgsAdminApiV1AdminOrgsGet(skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Run Admin
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunAdminApiV1AdminRunsRunIdGet: function (runId, options) {
            return localVarFp.readRunAdminApiV1AdminRunsRunIdGet(runId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Runs Admin
         * @param {string | null} [ownerId]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunsAdminApiV1AdminRunsGet: function (ownerId, skip, limit, options) {
            return localVarFp.readRunsAdminApiV1AdminRunsGet(ownerId, skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Salesforce Entities Admin
         * @param {string} ownerId
         * @param {string} instanceUrl
         * @param {SalesforceObjectType} sObjectType
         * @param {string} cols
         * @param {string} query
         * @param {string | null} [recordType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet: function (ownerId, instanceUrl, sObjectType, cols, query, recordType, options) {
            return localVarFp.readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet(ownerId, instanceUrl, sObjectType, cols, query, recordType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Subscription Admin
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet: function (subscriptionId, options) {
            return localVarFp.readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet(subscriptionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Subscriptions Admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionsAdminApiV1AdminSubscriptionsGet: function (options) {
            return localVarFp.readSubscriptionsAdminApiV1AdminSubscriptionsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user\'s templates.
         * @summary Read Templates Admin
         * @param {string} [ownerId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplatesAdminApiV1AdminTemplatesGet: function (ownerId, limit, skip, options) {
            return localVarFp.readTemplatesAdminApiV1AdminTemplatesGet(ownerId, limit, skip, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all users.
         * @summary Read Users Admin
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string | null} [orgId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUsersAdminApiV1AdminUserGet: function (skip, limit, orgId, options) {
            return localVarFp.readUsersAdminApiV1AdminUserGet(skip, limit, orgId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Run flow admin.
         * @summary Run Flow Admin
         * @param {string} flowId
         * @param {Array<string>} [envVarsOverride]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runFlowAdminApiV1AdminFlowsFlowIdStartPost: function (flowId, envVarsOverride, options) {
            return localVarFp.runFlowAdminApiV1AdminFlowsFlowIdStartPost(flowId, envVarsOverride, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Stops running flow.
         * @summary Stop Flow Admin
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopFlowAdminApiV1AdminFlowsFlowIdStopDelete: function (flowId, options) {
            return localVarFp.stopFlowAdminApiV1AdminFlowsFlowIdStopDelete(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Test Sentry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSentryApiV1AdminSentryGet: function (options) {
            return localVarFp.testSentryApiV1AdminSentryGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an case.
         * @summary Update Case Admin
         * @param {string} id
         * @param {CaseUpdateAdmin} caseUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAdminApiV1AdminCasesIdPut: function (id, caseUpdateAdmin, options) {
            return localVarFp.updateCaseAdminApiV1AdminCasesIdPut(id, caseUpdateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update flow admin.
         * @summary Update Flow Admin
         * @param {string} flowId
         * @param {FlowUpdateAdmin} flowUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowAdminApiV1AdminFlowsFlowIdPut: function (flowId, flowUpdateAdmin, options) {
            return localVarFp.updateFlowAdminApiV1AdminFlowsFlowIdPut(flowId, flowUpdateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an org.
         * @summary Update Org Admin
         * @param {string} id
         * @param {OrgUpdateAdmin} orgUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgAdminApiV1AdminOrgsIdPut: function (id, orgUpdateAdmin, options) {
            return localVarFp.updateOrgAdminApiV1AdminOrgsIdPut(id, orgUpdateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update template.
         * @summary Update Template Admin
         * @param {string} templateId
         * @param {TemplateUpdateAdmin} templateUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateAdminApiV1AdminTemplatesTemplateIdPut: function (templateId, templateUpdateAdmin, options) {
            return localVarFp.updateTemplateAdminApiV1AdminTemplatesTemplateIdPut(templateId, templateUpdateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a user admin
         * @summary Update User Admin
         * @param {string} userId
         * @param {UserUpdateAdmin} userUpdateAdmin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAdminApiV1AdminUserUserIdPut: function (userId, userUpdateAdmin, options) {
            return localVarFp.updateUserAdminApiV1AdminUserUserIdPut(userId, userUpdateAdmin, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Checkout Admin
     * @param {string} userId
     * @param {string} plan
     * @param {string} successUrl
     * @param {string} cancelUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.checkoutAdminApiV1AdminSubscriptionsCheckoutGet = function (userId, plan, successUrl, cancelUrl, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).checkoutAdminApiV1AdminSubscriptionsCheckoutGet(userId, plan, successUrl, cancelUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new case.
     * @summary Create Case Admin
     * @param {CaseCreateAdmin} caseCreateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createCaseAdminApiV1AdminCasesPost = function (caseCreateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createCaseAdminApiV1AdminCasesPost(caseCreateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create flow admin.
     * @summary Create Flow Admin
     * @param {FlowCreateAdmin} flowCreateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createFlowAdminApiV1AdminFlowsPost = function (flowCreateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createFlowAdminApiV1AdminFlowsPost(flowCreateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a notif.
     * @summary Create Notif Admin
     * @param {string} userId
     * @param {Notif} notif
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createNotifAdminApiV1AdminNotifsPost = function (userId, notif, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createNotifAdminApiV1AdminNotifsPost(userId, notif, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new org.
     * @summary Create Org Admin
     * @param {OrgCreateAdmin} orgCreateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createOrgAdminApiV1AdminOrgsPost = function (orgCreateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createOrgAdminApiV1AdminOrgsPost(orgCreateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create template from flow admin.
     * @summary Create Template From Flow Admin
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost = function (flowId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createTemplateFromFlowAdminApiV1AdminFlowsFlowIdTemplatePost(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a user.
     * @summary Create User Admin
     * @param {UserCreateAdmin} userCreateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createUserAdminApiV1AdminUserPost = function (userCreateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).createUserAdminApiV1AdminUserPost(userCreateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Debug Run
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.debugRunApiV1AdminRunsRunIdDebugGet = function (runId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).debugRunApiV1AdminRunsRunIdDebugGet(runId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a case.
     * @summary Delete Case Admin
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteCaseAdminApiV1AdminCasesIdDelete = function (id, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteCaseAdminApiV1AdminCasesIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Flow Admin
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteFlowAdminApiV1AdminFlowsFlowIdDelete = function (flowId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteFlowAdminApiV1AdminFlowsFlowIdDelete(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Run Admin
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteRunAdminApiV1AdminRunsRunIdDelete = function (runId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteRunAdminApiV1AdminRunsRunIdDelete(runId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete template.
     * @summary Delete Template Admin
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete = function (templateId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteTemplateAdminApiV1AdminTemplatesTemplateIdDelete(templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a user.
     * @summary Delete User Admin
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.deleteUserAdminApiV1AdminUserUserIdDelete = function (userId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).deleteUserAdminApiV1AdminUserUserIdDelete(userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Escalate Instagram DM.
     * @summary Escalate Admin
     * @param {string} ownerId
     * @param {string} recipientId
     * @param {string} senderId
     * @param {string} senderUsername
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost = function (ownerId, recipientId, senderId, senderUsername, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).escalateAdminApiV1AdminMetaInstagramNewDmsEscalationPost(ownerId, recipientId, senderId, senderUsername, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Flow Json
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getFlowJsonApiV1AdminRunsRunIdFlowJsonGet = function (runId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).getFlowJsonApiV1AdminRunsRunIdFlowJsonGet(runId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.healthApiV1AdminHealthGet = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).healthApiV1AdminHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.pingApiV1AdminPingGet = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).pingApiV1AdminPingGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get cases.
     * @summary Read Cases Admin
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readCasesAdminApiV1AdminCasesGet = function (skip, limit, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readCasesAdminApiV1AdminCasesGet(skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Flow Admin
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readFlowAdminApiV1AdminFlowsFlowIdGet = function (flowId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readFlowAdminApiV1AdminFlowsFlowIdGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Flow Settings Admin
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet = function (flowId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readFlowSettingsAdminApiV1AdminFlowsFlowIdSettingsGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user\'s flows.
     * @summary Read Flows Admin
     * @param {string} ownerId
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readFlowsAdminApiV1AdminFlowsGet = function (ownerId, skip, limit, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readFlowsAdminApiV1AdminFlowsGet(ownerId, skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get issues.
     * @summary Read Issues Admin
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet = function (flowId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readIssuesAdminApiV1AdminFlowsFlowIdIssuesGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get orgs.
     * @summary Read Orgs Admin
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readOrgsAdminApiV1AdminOrgsGet = function (skip, limit, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readOrgsAdminApiV1AdminOrgsGet(skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Run Admin
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readRunAdminApiV1AdminRunsRunIdGet = function (runId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readRunAdminApiV1AdminRunsRunIdGet(runId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Runs Admin
     * @param {string | null} [ownerId]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readRunsAdminApiV1AdminRunsGet = function (ownerId, skip, limit, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readRunsAdminApiV1AdminRunsGet(ownerId, skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Salesforce Entities Admin
     * @param {string} ownerId
     * @param {string} instanceUrl
     * @param {SalesforceObjectType} sObjectType
     * @param {string} cols
     * @param {string} query
     * @param {string | null} [recordType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet = function (ownerId, instanceUrl, sObjectType, cols, query, recordType, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readSalesforceEntitiesAdminApiV1AdminOverridesSalesforceQueryGet(ownerId, instanceUrl, sObjectType, cols, query, recordType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Subscription Admin
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet = function (subscriptionId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readSubscriptionAdminApiV1AdminSubscriptionsSubscriptionIdGet(subscriptionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Subscriptions Admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readSubscriptionsAdminApiV1AdminSubscriptionsGet = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readSubscriptionsAdminApiV1AdminSubscriptionsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user\'s templates.
     * @summary Read Templates Admin
     * @param {string} [ownerId]
     * @param {number} [limit]
     * @param {number} [skip]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readTemplatesAdminApiV1AdminTemplatesGet = function (ownerId, limit, skip, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readTemplatesAdminApiV1AdminTemplatesGet(ownerId, limit, skip, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all users.
     * @summary Read Users Admin
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {string | null} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.readUsersAdminApiV1AdminUserGet = function (skip, limit, orgId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).readUsersAdminApiV1AdminUserGet(skip, limit, orgId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Run flow admin.
     * @summary Run Flow Admin
     * @param {string} flowId
     * @param {Array<string>} [envVarsOverride]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.runFlowAdminApiV1AdminFlowsFlowIdStartPost = function (flowId, envVarsOverride, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).runFlowAdminApiV1AdminFlowsFlowIdStartPost(flowId, envVarsOverride, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Stops running flow.
     * @summary Stop Flow Admin
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.stopFlowAdminApiV1AdminFlowsFlowIdStopDelete = function (flowId, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).stopFlowAdminApiV1AdminFlowsFlowIdStopDelete(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Test Sentry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.testSentryApiV1AdminSentryGet = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).testSentryApiV1AdminSentryGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an case.
     * @summary Update Case Admin
     * @param {string} id
     * @param {CaseUpdateAdmin} caseUpdateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateCaseAdminApiV1AdminCasesIdPut = function (id, caseUpdateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateCaseAdminApiV1AdminCasesIdPut(id, caseUpdateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update flow admin.
     * @summary Update Flow Admin
     * @param {string} flowId
     * @param {FlowUpdateAdmin} flowUpdateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateFlowAdminApiV1AdminFlowsFlowIdPut = function (flowId, flowUpdateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateFlowAdminApiV1AdminFlowsFlowIdPut(flowId, flowUpdateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an org.
     * @summary Update Org Admin
     * @param {string} id
     * @param {OrgUpdateAdmin} orgUpdateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateOrgAdminApiV1AdminOrgsIdPut = function (id, orgUpdateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateOrgAdminApiV1AdminOrgsIdPut(id, orgUpdateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update template.
     * @summary Update Template Admin
     * @param {string} templateId
     * @param {TemplateUpdateAdmin} templateUpdateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateTemplateAdminApiV1AdminTemplatesTemplateIdPut = function (templateId, templateUpdateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateTemplateAdminApiV1AdminTemplatesTemplateIdPut(templateId, templateUpdateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a user admin
     * @summary Update User Admin
     * @param {string} userId
     * @param {UserUpdateAdmin} userUpdateAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.updateUserAdminApiV1AdminUserUserIdPut = function (userId, userUpdateAdmin, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).updateUserAdminApiV1AdminUserUserIdPut(userId, userUpdateAdmin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
/**
 * AuthApi - axios parameter creator
 * @export
 */
var AuthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Auth Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApiApiV1AuthAuthGoogleApiGet: function (redirectUrl_1, code_1, state_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([redirectUrl_1, code_1, state_1], args_1, true), void 0, function (redirectUrl, code, state, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('authApiApiV1AuthAuthGoogleApiGet', 'redirectUrl', redirectUrl);
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('authApiApiV1AuthAuthGoogleApiGet', 'code', code);
                            // verify required parameter 'state' is not null or undefined
                            (0, common_1.assertParamExists)('authApiApiV1AuthAuthGoogleApiGet', 'state', state);
                            localVarPath = "/api/v1/auth/auth-google-api";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (state !== undefined) {
                                localVarQueryParameter['state'] = state;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Email
         * @param {string} email
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailApiV1AuthAuthEmailPost: function (email_1, password_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([email_1, password_1], args_1, true), void 0, function (email, password, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'email' is not null or undefined
                    (0, common_1.assertParamExists)('authEmailApiV1AuthAuthEmailPost', 'email', email);
                    // verify required parameter 'password' is not null or undefined
                    (0, common_1.assertParamExists)('authEmailApiV1AuthAuthEmailPost', 'password', password);
                    localVarPath = "/api/v1/auth/auth-email";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (email !== undefined) {
                        localVarFormParams.set('email', email);
                    }
                    if (password !== undefined) {
                        localVarFormParams.set('password', password);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Auth Facebook
         * @param {string} authToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authFacebookApiV1AuthAuthFacebookGet: function (authToken_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authToken_1], args_1, true), void 0, function (authToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'authToken' is not null or undefined
                    (0, common_1.assertParamExists)('authFacebookApiV1AuthAuthFacebookGet', 'authToken', authToken);
                    localVarPath = "/api/v1/auth/auth-facebook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (authToken !== undefined) {
                        localVarQueryParameter['auth_token'] = authToken;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Auth Generic
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGenericApiV1AuthAuthApiGet: function (redirectUrl_1, code_1, state_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([redirectUrl_1, code_1, state_1], args_1, true), void 0, function (redirectUrl, code, state, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('authGenericApiV1AuthAuthApiGet', 'redirectUrl', redirectUrl);
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('authGenericApiV1AuthAuthApiGet', 'code', code);
                            // verify required parameter 'state' is not null or undefined
                            (0, common_1.assertParamExists)('authGenericApiV1AuthAuthApiGet', 'state', state);
                            localVarPath = "/api/v1/auth/auth-api";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (state !== undefined) {
                                localVarQueryParameter['state'] = state;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Google
         * @param {string} redirectUrl
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGoogleApiV1AuthAuthGoogleGet: function (redirectUrl_1, code_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([redirectUrl_1, code_1], args_1, true), void 0, function (redirectUrl, code, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'redirectUrl' is not null or undefined
                    (0, common_1.assertParamExists)('authGoogleApiV1AuthAuthGoogleGet', 'redirectUrl', redirectUrl);
                    // verify required parameter 'code' is not null or undefined
                    (0, common_1.assertParamExists)('authGoogleApiV1AuthAuthGoogleGet', 'code', code);
                    localVarPath = "/api/v1/auth/auth-google";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirect_url'] = redirectUrl;
                    }
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Auth Hubspot Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authHubspotApiApiV1AuthAuthHubspotApiGet: function (redirectUrl_1, code_1, state_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([redirectUrl_1, code_1, state_1], args_1, true), void 0, function (redirectUrl, code, state, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('authHubspotApiApiV1AuthAuthHubspotApiGet', 'redirectUrl', redirectUrl);
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('authHubspotApiApiV1AuthAuthHubspotApiGet', 'code', code);
                            // verify required parameter 'state' is not null or undefined
                            (0, common_1.assertParamExists)('authHubspotApiApiV1AuthAuthHubspotApiGet', 'state', state);
                            localVarPath = "/api/v1/auth/auth-hubspot-api";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (state !== undefined) {
                                localVarQueryParameter['state'] = state;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Salesforce Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSalesforceApiApiV1AuthAuthSalesforceApiGet: function (redirectUrl_1, code_1, state_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([redirectUrl_1, code_1, state_1], args_1, true), void 0, function (redirectUrl, code, state, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('authSalesforceApiApiV1AuthAuthSalesforceApiGet', 'redirectUrl', redirectUrl);
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('authSalesforceApiApiV1AuthAuthSalesforceApiGet', 'code', code);
                            // verify required parameter 'state' is not null or undefined
                            (0, common_1.assertParamExists)('authSalesforceApiApiV1AuthAuthSalesforceApiGet', 'state', state);
                            localVarPath = "/api/v1/auth/auth-salesforce-api";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (state !== undefined) {
                                localVarQueryParameter['state'] = state;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Connect Instagram Account
         * @param {ConnectInstagramAccount} connectInstagramAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost: function (connectInstagramAccount_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([connectInstagramAccount_1], args_1, true), void 0, function (connectInstagramAccount, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'connectInstagramAccount' is not null or undefined
                            (0, common_1.assertParamExists)('connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost', 'connectInstagramAccount', connectInstagramAccount);
                            localVarPath = "/api/v1/auth/meta/connect-instagram-account";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(connectInstagramAccount, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete All Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllTokensApiV1AuthTokenAllDelete: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/auth/token/all";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Token
         * @param {string} tokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTokenApiV1AuthTokenTokenIdDelete: function (tokenId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tokenId_1], args_1, true), void 0, function (tokenId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tokenId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTokenApiV1AuthTokenTokenIdDelete', 'tokenId', tokenId);
                            localVarPath = "/api/v1/auth/token/{token_id}"
                                .replace("{".concat("token_id", "}"), encodeURIComponent(String(tokenId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Refresh Token
         * @param {string} scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefreshTokenApiV1AuthRefreshTokenGet: function (scopes_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scopes_1], args_1, true), void 0, function (scopes, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scopes' is not null or undefined
                            (0, common_1.assertParamExists)('getRefreshTokenApiV1AuthRefreshTokenGet', 'scopes', scopes);
                            localVarPath = "/api/v1/auth/refresh_token";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (scopes !== undefined) {
                                localVarQueryParameter['scopes'] = scopes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This is an endpoint for a service to get a refreshed token. It is NOT meant to be used by the user.
         * @summary Get Token
         * @param {string} scopes
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenApiV1AuthTokenGet: function (scopes_1, email_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scopes_1, email_1], args_1, true), void 0, function (scopes, email, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scopes' is not null or undefined
                            (0, common_1.assertParamExists)('getTokenApiV1AuthTokenGet', 'scopes', scopes);
                            localVarPath = "/api/v1/auth/token";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (scopes !== undefined) {
                                localVarQueryParameter['scopes'] = scopes;
                            }
                            if (email !== undefined) {
                                localVarQueryParameter['email'] = email;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Login Auth
         * @param {string} flowId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthApiV1AuthLoginOauthGet: function (flowId_1, redirectUrl_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, redirectUrl_1], args_1, true), void 0, function (flowId, redirectUrl, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('loginAuthApiV1AuthLoginOauthGet', 'flowId', flowId);
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('loginAuthApiV1AuthLoginOauthGet', 'redirectUrl', redirectUrl);
                            localVarPath = "/api/v1/auth/login-oauth";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (flowId !== undefined) {
                                localVarQueryParameter['flow_id'] = flowId;
                            }
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Login Google
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginGoogleApiV1AuthLoginGoogleGet: function (redirectUrl_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([redirectUrl_1], args_1, true), void 0, function (redirectUrl, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'redirectUrl' is not null or undefined
                    (0, common_1.assertParamExists)('loginGoogleApiV1AuthLoginGoogleGet', 'redirectUrl', redirectUrl);
                    localVarPath = "/api/v1/auth/login-google";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (redirectUrl !== undefined) {
                        localVarQueryParameter['redirect_url'] = redirectUrl;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTokensApiV1AuthMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/auth/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Password Recovery
         * @summary Recover Password
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPasswordApiV1AuthPasswordRecoveryEmailPost: function (email_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([email_1], args_1, true), void 0, function (email, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'email' is not null or undefined
                    (0, common_1.assertParamExists)('recoverPasswordApiV1AuthPasswordRecoveryEmailPost', 'email', email);
                    localVarPath = "/api/v1/auth/password-recovery/{email}"
                        .replace("{".concat("email", "}"), encodeURIComponent(String(email)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Request Password Reset
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordResetApiV1AuthRequestPasswordResetPost: function (email_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([email_1], args_1, true), void 0, function (email, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'email' is not null or undefined
                    (0, common_1.assertParamExists)('requestPasswordResetApiV1AuthRequestPasswordResetPost', 'email', email);
                    localVarPath = "/api/v1/auth/request-password-reset";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (email !== undefined) {
                        localVarFormParams.set('email', email);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Reset Password
         * @param {string} password
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordApiV1AuthResetPasswordPost: function (password_1, token_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([password_1, token_1], args_1, true), void 0, function (password, token, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'password' is not null or undefined
                    (0, common_1.assertParamExists)('resetPasswordApiV1AuthResetPasswordPost', 'password', password);
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('resetPasswordApiV1AuthResetPasswordPost', 'token', token);
                    localVarPath = "/api/v1/auth/reset-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (password !== undefined) {
                        localVarFormParams.set('password', password);
                    }
                    if (token !== undefined) {
                        localVarFormParams.set('token', token);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Validate Email Address
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailAddressApiV1AuthValidateEmailAddressPost: function (token_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([token_1], args_1, true), void 0, function (token, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('validateEmailAddressApiV1AuthValidateEmailAddressPost', 'token', token);
                    localVarPath = "/api/v1/auth/validate-email-address";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (token !== undefined) {
                        localVarFormParams.set('token', token);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AuthApiAxiosParamCreator = AuthApiAxiosParamCreator;
/**
 * AuthApi - functional programming interface
 * @export
 */
var AuthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Auth Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApiApiV1AuthAuthGoogleApiGet: function (redirectUrl, code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authApiApiV1AuthAuthGoogleApiGet(redirectUrl, code, state, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authApiApiV1AuthAuthGoogleApiGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Email
         * @param {string} email
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailApiV1AuthAuthEmailPost: function (email, password, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authEmailApiV1AuthAuthEmailPost(email, password, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authEmailApiV1AuthAuthEmailPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Facebook
         * @param {string} authToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authFacebookApiV1AuthAuthFacebookGet: function (authToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authFacebookApiV1AuthAuthFacebookGet(authToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authFacebookApiV1AuthAuthFacebookGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Generic
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGenericApiV1AuthAuthApiGet: function (redirectUrl, code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authGenericApiV1AuthAuthApiGet(redirectUrl, code, state, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authGenericApiV1AuthAuthApiGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Google
         * @param {string} redirectUrl
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGoogleApiV1AuthAuthGoogleGet: function (redirectUrl, code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authGoogleApiV1AuthAuthGoogleGet(redirectUrl, code, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authGoogleApiV1AuthAuthGoogleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Hubspot Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authHubspotApiApiV1AuthAuthHubspotApiGet: function (redirectUrl, code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authHubspotApiApiV1AuthAuthHubspotApiGet(redirectUrl, code, state, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authHubspotApiApiV1AuthAuthHubspotApiGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth Salesforce Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSalesforceApiApiV1AuthAuthSalesforceApiGet: function (redirectUrl, code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authSalesforceApiApiV1AuthAuthSalesforceApiGet(redirectUrl, code, state, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authSalesforceApiApiV1AuthAuthSalesforceApiGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Connect Instagram Account
         * @param {ConnectInstagramAccount} connectInstagramAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost: function (connectInstagramAccount, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost(connectInstagramAccount, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete All Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllTokensApiV1AuthTokenAllDelete: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAllTokensApiV1AuthTokenAllDelete(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.deleteAllTokensApiV1AuthTokenAllDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Token
         * @param {string} tokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTokenApiV1AuthTokenTokenIdDelete: function (tokenId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTokenApiV1AuthTokenTokenIdDelete(tokenId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.deleteTokenApiV1AuthTokenTokenIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Refresh Token
         * @param {string} scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefreshTokenApiV1AuthRefreshTokenGet: function (scopes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRefreshTokenApiV1AuthRefreshTokenGet(scopes, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.getRefreshTokenApiV1AuthRefreshTokenGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This is an endpoint for a service to get a refreshed token. It is NOT meant to be used by the user.
         * @summary Get Token
         * @param {string} scopes
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenApiV1AuthTokenGet: function (scopes, email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTokenApiV1AuthTokenGet(scopes, email, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.getTokenApiV1AuthTokenGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Login Auth
         * @param {string} flowId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthApiV1AuthLoginOauthGet: function (flowId, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginAuthApiV1AuthLoginOauthGet(flowId, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.loginAuthApiV1AuthLoginOauthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Login Google
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginGoogleApiV1AuthLoginGoogleGet: function (redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginGoogleApiV1AuthLoginGoogleGet(redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.loginGoogleApiV1AuthLoginGoogleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTokensApiV1AuthMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readTokensApiV1AuthMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.readTokensApiV1AuthMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Password Recovery
         * @summary Recover Password
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPasswordApiV1AuthPasswordRecoveryEmailPost: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.recoverPasswordApiV1AuthPasswordRecoveryEmailPost(email, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.recoverPasswordApiV1AuthPasswordRecoveryEmailPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request Password Reset
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordResetApiV1AuthRequestPasswordResetPost: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestPasswordResetApiV1AuthRequestPasswordResetPost(email, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.requestPasswordResetApiV1AuthRequestPasswordResetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Reset Password
         * @param {string} password
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordApiV1AuthResetPasswordPost: function (password, token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetPasswordApiV1AuthResetPasswordPost(password, token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.resetPasswordApiV1AuthResetPasswordPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Validate Email Address
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailAddressApiV1AuthValidateEmailAddressPost: function (token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.validateEmailAddressApiV1AuthValidateEmailAddressPost(token, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.validateEmailAddressApiV1AuthValidateEmailAddressPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AuthApiFp = AuthApiFp;
/**
 * AuthApi - factory interface
 * @export
 */
var AuthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthApiFp)(configuration);
    return {
        /**
         *
         * @summary Auth Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApiApiV1AuthAuthGoogleApiGet: function (redirectUrl, code, state, options) {
            return localVarFp.authApiApiV1AuthAuthGoogleApiGet(redirectUrl, code, state, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth Email
         * @param {string} email
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailApiV1AuthAuthEmailPost: function (email, password, options) {
            return localVarFp.authEmailApiV1AuthAuthEmailPost(email, password, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth Facebook
         * @param {string} authToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authFacebookApiV1AuthAuthFacebookGet: function (authToken, options) {
            return localVarFp.authFacebookApiV1AuthAuthFacebookGet(authToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth Generic
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGenericApiV1AuthAuthApiGet: function (redirectUrl, code, state, options) {
            return localVarFp.authGenericApiV1AuthAuthApiGet(redirectUrl, code, state, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth Google
         * @param {string} redirectUrl
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGoogleApiV1AuthAuthGoogleGet: function (redirectUrl, code, options) {
            return localVarFp.authGoogleApiV1AuthAuthGoogleGet(redirectUrl, code, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth Hubspot Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authHubspotApiApiV1AuthAuthHubspotApiGet: function (redirectUrl, code, state, options) {
            return localVarFp.authHubspotApiApiV1AuthAuthHubspotApiGet(redirectUrl, code, state, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth Salesforce Api
         * @param {string} redirectUrl
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSalesforceApiApiV1AuthAuthSalesforceApiGet: function (redirectUrl, code, state, options) {
            return localVarFp.authSalesforceApiApiV1AuthAuthSalesforceApiGet(redirectUrl, code, state, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Connect Instagram Account
         * @param {ConnectInstagramAccount} connectInstagramAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost: function (connectInstagramAccount, options) {
            return localVarFp.connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost(connectInstagramAccount, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete All Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllTokensApiV1AuthTokenAllDelete: function (options) {
            return localVarFp.deleteAllTokensApiV1AuthTokenAllDelete(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Token
         * @param {string} tokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTokenApiV1AuthTokenTokenIdDelete: function (tokenId, options) {
            return localVarFp.deleteTokenApiV1AuthTokenTokenIdDelete(tokenId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Refresh Token
         * @param {string} scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefreshTokenApiV1AuthRefreshTokenGet: function (scopes, options) {
            return localVarFp.getRefreshTokenApiV1AuthRefreshTokenGet(scopes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This is an endpoint for a service to get a refreshed token. It is NOT meant to be used by the user.
         * @summary Get Token
         * @param {string} scopes
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenApiV1AuthTokenGet: function (scopes, email, options) {
            return localVarFp.getTokenApiV1AuthTokenGet(scopes, email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Login Auth
         * @param {string} flowId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthApiV1AuthLoginOauthGet: function (flowId, redirectUrl, options) {
            return localVarFp.loginAuthApiV1AuthLoginOauthGet(flowId, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Login Google
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginGoogleApiV1AuthLoginGoogleGet: function (redirectUrl, options) {
            return localVarFp.loginGoogleApiV1AuthLoginGoogleGet(redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTokensApiV1AuthMeGet: function (options) {
            return localVarFp.readTokensApiV1AuthMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Password Recovery
         * @summary Recover Password
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverPasswordApiV1AuthPasswordRecoveryEmailPost: function (email, options) {
            return localVarFp.recoverPasswordApiV1AuthPasswordRecoveryEmailPost(email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request Password Reset
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordResetApiV1AuthRequestPasswordResetPost: function (email, options) {
            return localVarFp.requestPasswordResetApiV1AuthRequestPasswordResetPost(email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Reset Password
         * @param {string} password
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordApiV1AuthResetPasswordPost: function (password, token, options) {
            return localVarFp.resetPasswordApiV1AuthResetPasswordPost(password, token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Validate Email Address
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailAddressApiV1AuthValidateEmailAddressPost: function (token, options) {
            return localVarFp.validateEmailAddressApiV1AuthValidateEmailAddressPost(token, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthApiFactory = AuthApiFactory;
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
var AuthApi = /** @class */ (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Auth Api
     * @param {string} redirectUrl
     * @param {string} code
     * @param {string} state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authApiApiV1AuthAuthGoogleApiGet = function (redirectUrl, code, state, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authApiApiV1AuthAuthGoogleApiGet(redirectUrl, code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth Email
     * @param {string} email
     * @param {string} password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authEmailApiV1AuthAuthEmailPost = function (email, password, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authEmailApiV1AuthAuthEmailPost(email, password, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth Facebook
     * @param {string} authToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authFacebookApiV1AuthAuthFacebookGet = function (authToken, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authFacebookApiV1AuthAuthFacebookGet(authToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth Generic
     * @param {string} redirectUrl
     * @param {string} code
     * @param {string} state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authGenericApiV1AuthAuthApiGet = function (redirectUrl, code, state, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authGenericApiV1AuthAuthApiGet(redirectUrl, code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth Google
     * @param {string} redirectUrl
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authGoogleApiV1AuthAuthGoogleGet = function (redirectUrl, code, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authGoogleApiV1AuthAuthGoogleGet(redirectUrl, code, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth Hubspot Api
     * @param {string} redirectUrl
     * @param {string} code
     * @param {string} state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authHubspotApiApiV1AuthAuthHubspotApiGet = function (redirectUrl, code, state, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authHubspotApiApiV1AuthAuthHubspotApiGet(redirectUrl, code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth Salesforce Api
     * @param {string} redirectUrl
     * @param {string} code
     * @param {string} state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authSalesforceApiApiV1AuthAuthSalesforceApiGet = function (redirectUrl, code, state, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authSalesforceApiApiV1AuthAuthSalesforceApiGet(redirectUrl, code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Connect Instagram Account
     * @param {ConnectInstagramAccount} connectInstagramAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost = function (connectInstagramAccount, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).connectInstagramAccountApiV1AuthMetaConnectInstagramAccountPost(connectInstagramAccount, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete All Tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.deleteAllTokensApiV1AuthTokenAllDelete = function (options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).deleteAllTokensApiV1AuthTokenAllDelete(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Token
     * @param {string} tokenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.deleteTokenApiV1AuthTokenTokenIdDelete = function (tokenId, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).deleteTokenApiV1AuthTokenTokenIdDelete(tokenId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Refresh Token
     * @param {string} scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.getRefreshTokenApiV1AuthRefreshTokenGet = function (scopes, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).getRefreshTokenApiV1AuthRefreshTokenGet(scopes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This is an endpoint for a service to get a refreshed token. It is NOT meant to be used by the user.
     * @summary Get Token
     * @param {string} scopes
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.getTokenApiV1AuthTokenGet = function (scopes, email, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).getTokenApiV1AuthTokenGet(scopes, email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Login Auth
     * @param {string} flowId
     * @param {string} redirectUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.loginAuthApiV1AuthLoginOauthGet = function (flowId, redirectUrl, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).loginAuthApiV1AuthLoginOauthGet(flowId, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Login Google
     * @param {string} redirectUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.loginGoogleApiV1AuthLoginGoogleGet = function (redirectUrl, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).loginGoogleApiV1AuthLoginGoogleGet(redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.readTokensApiV1AuthMeGet = function (options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).readTokensApiV1AuthMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Password Recovery
     * @summary Recover Password
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.recoverPasswordApiV1AuthPasswordRecoveryEmailPost = function (email, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).recoverPasswordApiV1AuthPasswordRecoveryEmailPost(email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request Password Reset
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.requestPasswordResetApiV1AuthRequestPasswordResetPost = function (email, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).requestPasswordResetApiV1AuthRequestPasswordResetPost(email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Reset Password
     * @param {string} password
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.resetPasswordApiV1AuthResetPasswordPost = function (password, token, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).resetPasswordApiV1AuthResetPasswordPost(password, token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Validate Email Address
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.validateEmailAddressApiV1AuthValidateEmailAddressPost = function (token, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).validateEmailAddressApiV1AuthValidateEmailAddressPost(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthApi;
}(base_1.BaseAPI));
exports.AuthApi = AuthApi;
/**
 * CasesApi - axios parameter creator
 * @export
 */
var CasesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete a case.
         * @summary Delete Case
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCaseApiV1CasesIdDelete: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteCaseApiV1CasesIdDelete', 'id', id);
                            localVarPath = "/api/v1/cases/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get case\'s runs.
         * @summary Read Case Runs
         * @param {string} caseId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCaseRunsApiV1CasesCaseIdRunsGet: function (caseId_1, skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([caseId_1, skip_1, limit_1], args_1, true), void 0, function (caseId, skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'caseId' is not null or undefined
                            (0, common_1.assertParamExists)('readCaseRunsApiV1CasesCaseIdRunsGet', 'caseId', caseId);
                            localVarPath = "/api/v1/cases/{case_id}/runs"
                                .replace("{".concat("case_id", "}"), encodeURIComponent(String(caseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get cases.
         * @summary Read Cases
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCasesApiV1CasesMeGet: function (skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([skip_1, limit_1], args_1, true), void 0, function (skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/cases/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CasesApiAxiosParamCreator = CasesApiAxiosParamCreator;
/**
 * CasesApi - functional programming interface
 * @export
 */
var CasesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CasesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete a case.
         * @summary Delete Case
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCaseApiV1CasesIdDelete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCaseApiV1CasesIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CasesApi.deleteCaseApiV1CasesIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get case\'s runs.
         * @summary Read Case Runs
         * @param {string} caseId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCaseRunsApiV1CasesCaseIdRunsGet: function (caseId, skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readCaseRunsApiV1CasesCaseIdRunsGet(caseId, skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CasesApi.readCaseRunsApiV1CasesCaseIdRunsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get cases.
         * @summary Read Cases
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCasesApiV1CasesMeGet: function (skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readCasesApiV1CasesMeGet(skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CasesApi.readCasesApiV1CasesMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CasesApiFp = CasesApiFp;
/**
 * CasesApi - factory interface
 * @export
 */
var CasesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CasesApiFp)(configuration);
    return {
        /**
         * Delete a case.
         * @summary Delete Case
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCaseApiV1CasesIdDelete: function (id, options) {
            return localVarFp.deleteCaseApiV1CasesIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get case\'s runs.
         * @summary Read Case Runs
         * @param {string} caseId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCaseRunsApiV1CasesCaseIdRunsGet: function (caseId, skip, limit, options) {
            return localVarFp.readCaseRunsApiV1CasesCaseIdRunsGet(caseId, skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get cases.
         * @summary Read Cases
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCasesApiV1CasesMeGet: function (skip, limit, options) {
            return localVarFp.readCasesApiV1CasesMeGet(skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CasesApiFactory = CasesApiFactory;
/**
 * CasesApi - object-oriented interface
 * @export
 * @class CasesApi
 * @extends {BaseAPI}
 */
var CasesApi = /** @class */ (function (_super) {
    __extends(CasesApi, _super);
    function CasesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete a case.
     * @summary Delete Case
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    CasesApi.prototype.deleteCaseApiV1CasesIdDelete = function (id, options) {
        var _this = this;
        return (0, exports.CasesApiFp)(this.configuration).deleteCaseApiV1CasesIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get case\'s runs.
     * @summary Read Case Runs
     * @param {string} caseId
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    CasesApi.prototype.readCaseRunsApiV1CasesCaseIdRunsGet = function (caseId, skip, limit, options) {
        var _this = this;
        return (0, exports.CasesApiFp)(this.configuration).readCaseRunsApiV1CasesCaseIdRunsGet(caseId, skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get cases.
     * @summary Read Cases
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    CasesApi.prototype.readCasesApiV1CasesMeGet = function (skip, limit, options) {
        var _this = this;
        return (0, exports.CasesApiFp)(this.configuration).readCasesApiV1CasesMeGet(skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CasesApi;
}(base_1.BaseAPI));
exports.CasesApi = CasesApi;
/**
 * ContactApi - axios parameter creator
 * @export
 */
var ContactApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Contact New
         * @param {string} firstname
         * @param {string} lastname
         * @param {string} email
         * @param {string} company
         * @param {string} crm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactNewApiV1ContactContactNewPost: function (firstname_1, lastname_1, email_1, company_1, crm_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([firstname_1, lastname_1, email_1, company_1, crm_1], args_1, true), void 0, function (firstname, lastname, email, company, crm, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'firstname' is not null or undefined
                    (0, common_1.assertParamExists)('contactNewApiV1ContactContactNewPost', 'firstname', firstname);
                    // verify required parameter 'lastname' is not null or undefined
                    (0, common_1.assertParamExists)('contactNewApiV1ContactContactNewPost', 'lastname', lastname);
                    // verify required parameter 'email' is not null or undefined
                    (0, common_1.assertParamExists)('contactNewApiV1ContactContactNewPost', 'email', email);
                    // verify required parameter 'company' is not null or undefined
                    (0, common_1.assertParamExists)('contactNewApiV1ContactContactNewPost', 'company', company);
                    // verify required parameter 'crm' is not null or undefined
                    (0, common_1.assertParamExists)('contactNewApiV1ContactContactNewPost', 'crm', crm);
                    localVarPath = "/api/v1/contact/contact/new";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (firstname !== undefined) {
                        localVarFormParams.set('firstname', firstname);
                    }
                    if (lastname !== undefined) {
                        localVarFormParams.set('lastname', lastname);
                    }
                    if (email !== undefined) {
                        localVarFormParams.set('email', email);
                    }
                    if (company !== undefined) {
                        localVarFormParams.set('company', company);
                    }
                    if (crm !== undefined) {
                        localVarFormParams.set('crm', crm);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ContactApiAxiosParamCreator = ContactApiAxiosParamCreator;
/**
 * ContactApi - functional programming interface
 * @export
 */
var ContactApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContactApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Contact New
         * @param {string} firstname
         * @param {string} lastname
         * @param {string} email
         * @param {string} company
         * @param {string} crm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactNewApiV1ContactContactNewPost: function (firstname, lastname, email, company, crm, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contactNewApiV1ContactContactNewPost(firstname, lastname, email, company, crm, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactApi.contactNewApiV1ContactContactNewPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ContactApiFp = ContactApiFp;
/**
 * ContactApi - factory interface
 * @export
 */
var ContactApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContactApiFp)(configuration);
    return {
        /**
         *
         * @summary Contact New
         * @param {string} firstname
         * @param {string} lastname
         * @param {string} email
         * @param {string} company
         * @param {string} crm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactNewApiV1ContactContactNewPost: function (firstname, lastname, email, company, crm, options) {
            return localVarFp.contactNewApiV1ContactContactNewPost(firstname, lastname, email, company, crm, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContactApiFactory = ContactApiFactory;
/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
var ContactApi = /** @class */ (function (_super) {
    __extends(ContactApi, _super);
    function ContactApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Contact New
     * @param {string} firstname
     * @param {string} lastname
     * @param {string} email
     * @param {string} company
     * @param {string} crm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    ContactApi.prototype.contactNewApiV1ContactContactNewPost = function (firstname, lastname, email, company, crm, options) {
        var _this = this;
        return (0, exports.ContactApiFp)(this.configuration).contactNewApiV1ContactContactNewPost(firstname, lastname, email, company, crm, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContactApi;
}(base_1.BaseAPI));
exports.ContactApi = ContactApi;
/**
 * DummyApi - axios parameter creator
 * @export
 */
var DummyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get Dummy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDummyApiV1DummyGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/dummy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DummyApiAxiosParamCreator = DummyApiAxiosParamCreator;
/**
 * DummyApi - functional programming interface
 * @export
 */
var DummyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DummyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Dummy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDummyApiV1DummyGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDummyApiV1DummyGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DummyApi.getDummyApiV1DummyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DummyApiFp = DummyApiFp;
/**
 * DummyApi - factory interface
 * @export
 */
var DummyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DummyApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Dummy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDummyApiV1DummyGet: function (options) {
            return localVarFp.getDummyApiV1DummyGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DummyApiFactory = DummyApiFactory;
/**
 * DummyApi - object-oriented interface
 * @export
 * @class DummyApi
 * @extends {BaseAPI}
 */
var DummyApi = /** @class */ (function (_super) {
    __extends(DummyApi, _super);
    function DummyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get Dummy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DummyApi
     */
    DummyApi.prototype.getDummyApiV1DummyGet = function (options) {
        var _this = this;
        return (0, exports.DummyApiFp)(this.configuration).getDummyApiV1DummyGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DummyApi;
}(base_1.BaseAPI));
exports.DummyApi = DummyApi;
/**
 * FlowsApi - axios parameter creator
 * @export
 */
var FlowsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Add Source Handle
         * @param {string} flowId
         * @param {string} nodeId
         * @param {AddSourceHandle} addSourceHandle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost: function (flowId_1, nodeId_1, addSourceHandle_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, nodeId_1, addSourceHandle_1], args_1, true), void 0, function (flowId, nodeId, addSourceHandle, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost', 'flowId', flowId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost', 'nodeId', nodeId);
                            // verify required parameter 'addSourceHandle' is not null or undefined
                            (0, common_1.assertParamExists)('addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost', 'addSourceHandle', addSourceHandle);
                            localVarPath = "/api/v1/flows/{flow_id}/nodes/add-source-handle"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addSourceHandle, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add Target Handle
         * @param {string} flowId
         * @param {string} nodeId
         * @param {AddTargetHandle} addTargetHandle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost: function (flowId_1, nodeId_1, addTargetHandle_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, nodeId_1, addTargetHandle_1], args_1, true), void 0, function (flowId, nodeId, addTargetHandle, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost', 'flowId', flowId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost', 'nodeId', nodeId);
                            // verify required parameter 'addTargetHandle' is not null or undefined
                            (0, common_1.assertParamExists)('addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost', 'addTargetHandle', addTargetHandle);
                            localVarPath = "/api/v1/flows/{flow_id}/nodes/add-target-handle"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addTargetHandle, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Check Job
         * @param {string} jobId
         * @param {string | null} [flowId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkJobApiV1FlowsJobJobIdGet: function (jobId_1, flowId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([jobId_1, flowId_1], args_1, true), void 0, function (jobId, flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'jobId' is not null or undefined
                    (0, common_1.assertParamExists)('checkJobApiV1FlowsJobJobIdGet', 'jobId', jobId);
                    localVarPath = "/api/v1/flows/job/{job_id}"
                        .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (flowId !== undefined) {
                        localVarQueryParameter['flow_id'] = flowId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Chrome Resubmit Job
         * @param {string} flowId
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost: function (flowId_1, jobId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, jobId_1], args_1, true), void 0, function (flowId, jobId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost', 'flowId', flowId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost', 'jobId', jobId);
                            localVarPath = "/api/v1/flows/{flow_id}/chrome/resubmit/{job_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Chrome Submit
         * @param {string} flowId
         * @param {OutputSchema} outputSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeSubmitApiV1FlowsFlowIdChromeSubmitPost: function (flowId_1, outputSchema_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, outputSchema_1], args_1, true), void 0, function (flowId, outputSchema, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('chromeSubmitApiV1FlowsFlowIdChromeSubmitPost', 'flowId', flowId);
                            // verify required parameter 'outputSchema' is not null or undefined
                            (0, common_1.assertParamExists)('chromeSubmitApiV1FlowsFlowIdChromeSubmitPost', 'outputSchema', outputSchema);
                            localVarPath = "/api/v1/flows/{flow_id}/chrome/submit"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(outputSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Connect nodes.
         * @summary Connect Nodes
         * @param {string} flowId
         * @param {ConnectNodesCreate} connectNodesCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectNodesApiV1FlowsFlowIdConnectPost: function (flowId_1, connectNodesCreate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, connectNodesCreate_1], args_1, true), void 0, function (flowId, connectNodesCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('connectNodesApiV1FlowsFlowIdConnectPost', 'flowId', flowId);
                            // verify required parameter 'connectNodesCreate' is not null or undefined
                            (0, common_1.assertParamExists)('connectNodesApiV1FlowsFlowIdConnectPost', 'connectNodesCreate', connectNodesCreate);
                            localVarPath = "/api/v1/flows/{flow_id}/connect"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(connectNodesCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create flow.
         * @summary Create Flow
         * @param {FlowCreate} flowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowApiV1FlowsPost: function (flowCreate_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowCreate_1], args_1, true), void 0, function (flowCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowCreate' is not null or undefined
                            (0, common_1.assertParamExists)('createFlowApiV1FlowsPost', 'flowCreate', flowCreate);
                            localVarPath = "/api/v1/flows";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(flowCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Flow Env Var
         * @param {string} flowId
         * @param {FlowEnvVariableCreate} flowEnvVariableCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost: function (flowId_1, flowEnvVariableCreate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, flowEnvVariableCreate_1], args_1, true), void 0, function (flowId, flowEnvVariableCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost', 'flowId', flowId);
                            // verify required parameter 'flowEnvVariableCreate' is not null or undefined
                            (0, common_1.assertParamExists)('createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost', 'flowEnvVariableCreate', flowEnvVariableCreate);
                            localVarPath = "/api/v1/flows/{flow_id}/env-vars"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(flowEnvVariableCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Gsheet
         * @param {string} title
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGsheetApiV1FlowsSheetsPost: function (title_1, redirectUrl_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([title_1, redirectUrl_1], args_1, true), void 0, function (title, redirectUrl, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'title' is not null or undefined
                            (0, common_1.assertParamExists)('createGsheetApiV1FlowsSheetsPost', 'title', title);
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('createGsheetApiV1FlowsSheetsPost', 'redirectUrl', redirectUrl);
                            localVarPath = "/api/v1/flows/sheets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (title !== undefined) {
                                localVarQueryParameter['title'] = title;
                            }
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Node
         * @param {string} flowId
         * @param {NodeCreate} nodeCreate
         * @param {string | null} [subflowId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNodeApiV1FlowsFlowIdNodesPost: function (flowId_1, nodeCreate_1, subflowId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, nodeCreate_1, subflowId_1], args_1, true), void 0, function (flowId, nodeCreate, subflowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('createNodeApiV1FlowsFlowIdNodesPost', 'flowId', flowId);
                            // verify required parameter 'nodeCreate' is not null or undefined
                            (0, common_1.assertParamExists)('createNodeApiV1FlowsFlowIdNodesPost', 'nodeCreate', nodeCreate);
                            localVarPath = "/api/v1/flows/{flow_id}/nodes"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (subflowId !== undefined) {
                                localVarQueryParameter['subflow_id'] = subflowId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(nodeCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create subflow.
         * @summary Create Subflow
         * @param {string} flowId
         * @param {SubflowCreate} subflowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubflowApiV1FlowsFlowIdSubflowPost: function (flowId_1, subflowCreate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, subflowCreate_1], args_1, true), void 0, function (flowId, subflowCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('createSubflowApiV1FlowsFlowIdSubflowPost', 'flowId', flowId);
                            // verify required parameter 'subflowCreate' is not null or undefined
                            (0, common_1.assertParamExists)('createSubflowApiV1FlowsFlowIdSubflowPost', 'subflowCreate', subflowCreate);
                            localVarPath = "/api/v1/flows/{flow_id}/subflow"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subflowCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create template from flow.
         * @summary Create Template From Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromFlowApiV1FlowsFlowIdTemplatePost: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('createTemplateFromFlowApiV1FlowsFlowIdTemplatePost', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/template"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Debug Submit
         * @param {string} browserInfo
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugSubmitApiV1FlowsDebugFormSubmitPost: function (browserInfo_1, file_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([browserInfo_1, file_1], args_1, true), void 0, function (browserInfo, file, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'browserInfo' is not null or undefined
                    (0, common_1.assertParamExists)('debugSubmitApiV1FlowsDebugFormSubmitPost', 'browserInfo', browserInfo);
                    // verify required parameter 'file' is not null or undefined
                    (0, common_1.assertParamExists)('debugSubmitApiV1FlowsDebugFormSubmitPost', 'file', file);
                    localVarPath = "/api/v1/flows/debug/form/submit";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                    if (browserInfo !== undefined) {
                        localVarFormParams.append('browser_info', browserInfo);
                    }
                    if (file !== undefined) {
                        localVarFormParams.append('file', file);
                    }
                    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams;
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete flow.
         * @summary Delete Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowApiV1FlowsFlowIdDelete: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFlowApiV1FlowsFlowIdDelete', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Flow Env Var
         * @param {string} flowId
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete: function (flowId_1, envVarId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, envVarId_1], args_1, true), void 0, function (flowId, envVarId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete', 'flowId', flowId);
                            // verify required parameter 'envVarId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete', 'envVarId', envVarId);
                            localVarPath = "/api/v1/flows/{flow_id}/env-vars/{env_var_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)))
                                .replace("{".concat("env_var_id", "}"), encodeURIComponent(String(envVarId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Node
         * @param {string} flowId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete: function (flowId_1, nodeId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, nodeId_1], args_1, true), void 0, function (flowId, nodeId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete', 'flowId', flowId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete', 'nodeId', nodeId);
                            localVarPath = "/api/v1/flows/{flow_id}/nodes/{node_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Demo Hotel Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoHotelHealthApiV1FlowsDemoHotelHealthGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/flows/demo/hotel/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Demo Main Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoMainHealthApiV1FlowsDemoMainHealthGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/flows/demo/main/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Disconnect nodes.
         * @summary Disconnect Nodes
         * @param {string} flowId
         * @param {ConnectNodesCreate} connectNodesCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectNodesApiV1FlowsFlowIdDisconnectDelete: function (flowId_1, connectNodesCreate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, connectNodesCreate_1], args_1, true), void 0, function (flowId, connectNodesCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('disconnectNodesApiV1FlowsFlowIdDisconnectDelete', 'flowId', flowId);
                            // verify required parameter 'connectNodesCreate' is not null or undefined
                            (0, common_1.assertParamExists)('disconnectNodesApiV1FlowsFlowIdDisconnectDelete', 'connectNodesCreate', connectNodesCreate);
                            localVarPath = "/api/v1/flows/{flow_id}/disconnect"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(connectNodesCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Duplicate flow.
         * @summary Duplicate Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateFlowApiV1FlowsDuplicateFlowIdPost: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('duplicateFlowApiV1FlowsDuplicateFlowIdPost', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/duplicate/{flow_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Exec example data.
         * @summary Exec Example Data
         * @param {string} flowId
         * @param {string} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        execExampleDataApiV1FlowsFlowIdExamplePost: function (flowId_1, data_1, files_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, data_1, files_1], args_1, true), void 0, function (flowId, data, files, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('execExampleDataApiV1FlowsFlowIdExamplePost', 'flowId', flowId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('execExampleDataApiV1FlowsFlowIdExamplePost', 'data', data);
                            localVarPath = "/api/v1/flows/{flow_id}/example"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', data);
                            }
                            if (files) {
                                files.forEach(function (element) {
                                    localVarFormParams.append('files', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Form Json
         * @param {string} flowId
         * @param {string | null} [previousRunId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formJsonApiV1FlowsFlowIdFormSchemaGet: function (flowId_1, previousRunId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, previousRunId_1], args_1, true), void 0, function (flowId, previousRunId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('formJsonApiV1FlowsFlowIdFormSchemaGet', 'flowId', flowId);
                    localVarPath = "/api/v1/flows/{flow_id}/form/schema"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (previousRunId !== undefined) {
                        localVarQueryParameter['previous_run_id'] = previousRunId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Form Submit
         * @param {string} flowId
         * @param {string} formData
         * @param {Array<File>} [files]
         * @param {string | null} [previousRunId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSubmitApiV1FlowsFlowIdFormSubmitPost: function (flowId_1, formData_1, files_1, previousRunId_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, formData_1, files_1, previousRunId_1], args_1, true), void 0, function (flowId, formData, files, previousRunId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('formSubmitApiV1FlowsFlowIdFormSubmitPost', 'flowId', flowId);
                            // verify required parameter 'formData' is not null or undefined
                            (0, common_1.assertParamExists)('formSubmitApiV1FlowsFlowIdFormSubmitPost', 'formData', formData);
                            localVarPath = "/api/v1/flows/{flow_id}/form/submit"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (formData !== undefined) {
                                localVarFormParams.append('form_data', formData);
                            }
                            if (files) {
                                files.forEach(function (element) {
                                    localVarFormParams.append('files', element);
                                });
                            }
                            if (previousRunId !== undefined) {
                                localVarFormParams.append('previous_run_id', previousRunId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Form Widget Code
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formWidgetCodeApiV1FlowsFlowIdFormCodeGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('formWidgetCodeApiV1FlowsFlowIdFormCodeGet', 'flowId', flowId);
                    localVarPath = "/api/v1/flows/{flow_id}/form/code"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get template from flow.
         * @summary Get Template From Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFromFlowApiV1FlowsFlowIdTemplateGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('getTemplateFromFlowApiV1FlowsFlowIdTemplateGet', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/template"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mic Submit
         * @param {string} flowId
         * @param {File} recording
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        micSubmitApiV1FlowsFlowIdMicSubmitPost: function (flowId_1, recording_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, recording_1], args_1, true), void 0, function (flowId, recording, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('micSubmitApiV1FlowsFlowIdMicSubmitPost', 'flowId', flowId);
                            // verify required parameter 'recording' is not null or undefined
                            (0, common_1.assertParamExists)('micSubmitApiV1FlowsFlowIdMicSubmitPost', 'recording', recording);
                            localVarPath = "/api/v1/flows/{flow_id}/mic/submit"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (recording !== undefined) {
                                localVarFormParams.append('recording', recording);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Preview Form Json
         * @param {PreviewFormRequest} previewFormRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost: function (previewFormRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([previewFormRequest_1], args_1, true), void 0, function (previewFormRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'previewFormRequest' is not null or undefined
                    (0, common_1.assertParamExists)('previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost', 'previewFormRequest', previewFormRequest);
                    localVarPath = "/api/v1/flows/{flow_id}/nodes/preview/form";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(previewFormRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get example schema.
         * @summary Read Example Schema
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/example/schema"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get read_flow.
         * @summary Read Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowApiV1FlowsFlowIdGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('readFlowApiV1FlowsFlowIdGet', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Flow Env Vars
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/env-vars"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get read_flow.
         * @summary Read Flow Json
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowJsonApiV1FlowsFlowIdJsonGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'flowId' is not null or undefined
                    (0, common_1.assertParamExists)('readFlowJsonApiV1FlowsFlowIdJsonGet', 'flowId', flowId);
                    localVarPath = "/api/v1/flows/{flow_id}/json"
                        .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Flow Settings
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowSettingsApiV1FlowsFlowIdSettingsGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('readFlowSettingsApiV1FlowsFlowIdSettingsGet', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/settings"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get issues.
         * @summary Read Issues
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIssuesApiV1FlowsFlowIdIssuesGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('readIssuesApiV1FlowsFlowIdIssuesGet', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/issues"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1FlowsMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/flows/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Me Chrome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeChromeApiV1FlowsMeChromeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/flows/me/chrome";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Node Types
         * @param {string} [v]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNodeTypesApiV1FlowsNodesTypesGet: function (v_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([v_1], args_1, true), void 0, function (v, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/flows/nodes/types";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (v !== undefined) {
                        localVarQueryParameter['v'] = v;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Read the last 10 queued jobs and their status.
         * @summary Read Queued
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readQueuedApiV1FlowsFlowIdQGet: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('readQueuedApiV1FlowsFlowIdQGet', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/q"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get read_flow.
         * @summary Read Subflow
         * @param {string} flowId
         * @param {string} subflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet: function (flowId_1, subflowId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, subflowId_1], args_1, true), void 0, function (flowId, subflowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet', 'flowId', flowId);
                            // verify required parameter 'subflowId' is not null or undefined
                            (0, common_1.assertParamExists)('readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet', 'subflowId', subflowId);
                            localVarPath = "/api/v1/flows/{flow_id}/subflow/{subflow_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)))
                                .replace("{".concat("subflow_id", "}"), encodeURIComponent(String(subflowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create subflow.
         * @summary Simulate Subflow
         * @param {string} flowId
         * @param {SubflowCreate} subflowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost: function (flowId_1, subflowCreate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, subflowCreate_1], args_1, true), void 0, function (flowId, subflowCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost', 'flowId', flowId);
                            // verify required parameter 'subflowCreate' is not null or undefined
                            (0, common_1.assertParamExists)('simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost', 'subflowCreate', subflowCreate);
                            localVarPath = "/api/v1/flows/{flow_id}/subflow/simulate"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subflowCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Run flow.
         * @summary Start Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFlowApiV1FlowsFlowIdStartPost: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('startFlowApiV1FlowsFlowIdStartPost', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/start"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Stops running flow.
         * @summary Stop Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopFlowApiV1FlowsFlowIdStopDelete: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('stopFlowApiV1FlowsFlowIdStopDelete', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/stop"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create subflow.
         * @summary Ungroup Subflow
         * @param {string} flowId
         * @param {string} subflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost: function (flowId_1, subflowId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, subflowId_1], args_1, true), void 0, function (flowId, subflowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost', 'flowId', flowId);
                            // verify required parameter 'subflowId' is not null or undefined
                            (0, common_1.assertParamExists)('ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost', 'subflowId', subflowId);
                            localVarPath = "/api/v1/flows/{flow_id}/subflow/{subflow_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)))
                                .replace("{".concat("subflow_id", "}"), encodeURIComponent(String(subflowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update flow.
         * @summary Update Flow
         * @param {string} flowId
         * @param {FlowUpdate} flowUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowApiV1FlowsFlowIdPut: function (flowId_1, flowUpdate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, flowUpdate_1], args_1, true), void 0, function (flowId, flowUpdate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFlowApiV1FlowsFlowIdPut', 'flowId', flowId);
                            // verify required parameter 'flowUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateFlowApiV1FlowsFlowIdPut', 'flowUpdate', flowUpdate);
                            localVarPath = "/api/v1/flows/{flow_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(flowUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Node
         * @param {string} flowId
         * @param {string} nodeId
         * @param {NodeUpdate} nodeUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeApiV1FlowsFlowIdNodesNodeIdPut: function (flowId_1, nodeId_1, nodeUpdate_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1, nodeId_1, nodeUpdate_1], args_1, true), void 0, function (flowId, nodeId, nodeUpdate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('updateNodeApiV1FlowsFlowIdNodesNodeIdPut', 'flowId', flowId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateNodeApiV1FlowsFlowIdNodesNodeIdPut', 'nodeId', nodeId);
                            // verify required parameter 'nodeUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateNodeApiV1FlowsFlowIdNodesNodeIdPut', 'nodeUpdate', nodeUpdate);
                            localVarPath = "/api/v1/flows/{flow_id}/nodes/{node_id}"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(nodeUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Validate flow.
         * @summary Validate Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFlowApiV1FlowsFlowIdValidatePost: function (flowId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([flowId_1], args_1, true), void 0, function (flowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'flowId' is not null or undefined
                            (0, common_1.assertParamExists)('validateFlowApiV1FlowsFlowIdValidatePost', 'flowId', flowId);
                            localVarPath = "/api/v1/flows/{flow_id}/validate"
                                .replace("{".concat("flow_id", "}"), encodeURIComponent(String(flowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FlowsApiAxiosParamCreator = FlowsApiAxiosParamCreator;
/**
 * FlowsApi - functional programming interface
 * @export
 */
var FlowsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FlowsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Add Source Handle
         * @param {string} flowId
         * @param {string} nodeId
         * @param {AddSourceHandle} addSourceHandle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost: function (flowId, nodeId, addSourceHandle, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost(flowId, nodeId, addSourceHandle, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add Target Handle
         * @param {string} flowId
         * @param {string} nodeId
         * @param {AddTargetHandle} addTargetHandle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost: function (flowId, nodeId, addTargetHandle, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost(flowId, nodeId, addTargetHandle, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Check Job
         * @param {string} jobId
         * @param {string | null} [flowId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkJobApiV1FlowsJobJobIdGet: function (jobId, flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkJobApiV1FlowsJobJobIdGet(jobId, flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.checkJobApiV1FlowsJobJobIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Chrome Resubmit Job
         * @param {string} flowId
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost: function (flowId, jobId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost(flowId, jobId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Chrome Submit
         * @param {string} flowId
         * @param {OutputSchema} outputSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeSubmitApiV1FlowsFlowIdChromeSubmitPost: function (flowId, outputSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.chromeSubmitApiV1FlowsFlowIdChromeSubmitPost(flowId, outputSchema, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.chromeSubmitApiV1FlowsFlowIdChromeSubmitPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Connect nodes.
         * @summary Connect Nodes
         * @param {string} flowId
         * @param {ConnectNodesCreate} connectNodesCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectNodesApiV1FlowsFlowIdConnectPost: function (flowId, connectNodesCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.connectNodesApiV1FlowsFlowIdConnectPost(flowId, connectNodesCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.connectNodesApiV1FlowsFlowIdConnectPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create flow.
         * @summary Create Flow
         * @param {FlowCreate} flowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowApiV1FlowsPost: function (flowCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFlowApiV1FlowsPost(flowCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.createFlowApiV1FlowsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Flow Env Var
         * @param {string} flowId
         * @param {FlowEnvVariableCreate} flowEnvVariableCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost: function (flowId, flowEnvVariableCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost(flowId, flowEnvVariableCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Gsheet
         * @param {string} title
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGsheetApiV1FlowsSheetsPost: function (title, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createGsheetApiV1FlowsSheetsPost(title, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.createGsheetApiV1FlowsSheetsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Node
         * @param {string} flowId
         * @param {NodeCreate} nodeCreate
         * @param {string | null} [subflowId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNodeApiV1FlowsFlowIdNodesPost: function (flowId, nodeCreate, subflowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNodeApiV1FlowsFlowIdNodesPost(flowId, nodeCreate, subflowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.createNodeApiV1FlowsFlowIdNodesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create subflow.
         * @summary Create Subflow
         * @param {string} flowId
         * @param {SubflowCreate} subflowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubflowApiV1FlowsFlowIdSubflowPost: function (flowId, subflowCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSubflowApiV1FlowsFlowIdSubflowPost(flowId, subflowCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.createSubflowApiV1FlowsFlowIdSubflowPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create template from flow.
         * @summary Create Template From Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromFlowApiV1FlowsFlowIdTemplatePost: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTemplateFromFlowApiV1FlowsFlowIdTemplatePost(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.createTemplateFromFlowApiV1FlowsFlowIdTemplatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Debug Submit
         * @param {string} browserInfo
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugSubmitApiV1FlowsDebugFormSubmitPost: function (browserInfo, file, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.debugSubmitApiV1FlowsDebugFormSubmitPost(browserInfo, file, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.debugSubmitApiV1FlowsDebugFormSubmitPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete flow.
         * @summary Delete Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowApiV1FlowsFlowIdDelete: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFlowApiV1FlowsFlowIdDelete(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.deleteFlowApiV1FlowsFlowIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Flow Env Var
         * @param {string} flowId
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete: function (flowId, envVarId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete(flowId, envVarId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Node
         * @param {string} flowId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete: function (flowId, nodeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete(flowId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Demo Hotel Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoHotelHealthApiV1FlowsDemoHotelHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.demoHotelHealthApiV1FlowsDemoHotelHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.demoHotelHealthApiV1FlowsDemoHotelHealthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Demo Main Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoMainHealthApiV1FlowsDemoMainHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.demoMainHealthApiV1FlowsDemoMainHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.demoMainHealthApiV1FlowsDemoMainHealthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Disconnect nodes.
         * @summary Disconnect Nodes
         * @param {string} flowId
         * @param {ConnectNodesCreate} connectNodesCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectNodesApiV1FlowsFlowIdDisconnectDelete: function (flowId, connectNodesCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.disconnectNodesApiV1FlowsFlowIdDisconnectDelete(flowId, connectNodesCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.disconnectNodesApiV1FlowsFlowIdDisconnectDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Duplicate flow.
         * @summary Duplicate Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateFlowApiV1FlowsDuplicateFlowIdPost: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.duplicateFlowApiV1FlowsDuplicateFlowIdPost(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.duplicateFlowApiV1FlowsDuplicateFlowIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Exec example data.
         * @summary Exec Example Data
         * @param {string} flowId
         * @param {string} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        execExampleDataApiV1FlowsFlowIdExamplePost: function (flowId, data, files, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.execExampleDataApiV1FlowsFlowIdExamplePost(flowId, data, files, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.execExampleDataApiV1FlowsFlowIdExamplePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Form Json
         * @param {string} flowId
         * @param {string | null} [previousRunId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formJsonApiV1FlowsFlowIdFormSchemaGet: function (flowId, previousRunId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.formJsonApiV1FlowsFlowIdFormSchemaGet(flowId, previousRunId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.formJsonApiV1FlowsFlowIdFormSchemaGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Form Submit
         * @param {string} flowId
         * @param {string} formData
         * @param {Array<File>} [files]
         * @param {string | null} [previousRunId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSubmitApiV1FlowsFlowIdFormSubmitPost: function (flowId, formData, files, previousRunId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.formSubmitApiV1FlowsFlowIdFormSubmitPost(flowId, formData, files, previousRunId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.formSubmitApiV1FlowsFlowIdFormSubmitPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Form Widget Code
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formWidgetCodeApiV1FlowsFlowIdFormCodeGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.formWidgetCodeApiV1FlowsFlowIdFormCodeGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.formWidgetCodeApiV1FlowsFlowIdFormCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get template from flow.
         * @summary Get Template From Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFromFlowApiV1FlowsFlowIdTemplateGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTemplateFromFlowApiV1FlowsFlowIdTemplateGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.getTemplateFromFlowApiV1FlowsFlowIdTemplateGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mic Submit
         * @param {string} flowId
         * @param {File} recording
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        micSubmitApiV1FlowsFlowIdMicSubmitPost: function (flowId, recording, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.micSubmitApiV1FlowsFlowIdMicSubmitPost(flowId, recording, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.micSubmitApiV1FlowsFlowIdMicSubmitPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Preview Form Json
         * @param {PreviewFormRequest} previewFormRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost: function (previewFormRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost(previewFormRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get example schema.
         * @summary Read Example Schema
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get read_flow.
         * @summary Read Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowApiV1FlowsFlowIdGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readFlowApiV1FlowsFlowIdGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readFlowApiV1FlowsFlowIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Flow Env Vars
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get read_flow.
         * @summary Read Flow Json
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowJsonApiV1FlowsFlowIdJsonGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readFlowJsonApiV1FlowsFlowIdJsonGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readFlowJsonApiV1FlowsFlowIdJsonGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Flow Settings
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowSettingsApiV1FlowsFlowIdSettingsGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readFlowSettingsApiV1FlowsFlowIdSettingsGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readFlowSettingsApiV1FlowsFlowIdSettingsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get issues.
         * @summary Read Issues
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIssuesApiV1FlowsFlowIdIssuesGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readIssuesApiV1FlowsFlowIdIssuesGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readIssuesApiV1FlowsFlowIdIssuesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1FlowsMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readMeApiV1FlowsMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readMeApiV1FlowsMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Me Chrome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeChromeApiV1FlowsMeChromeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readMeChromeApiV1FlowsMeChromeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readMeChromeApiV1FlowsMeChromeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Node Types
         * @param {string} [v]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNodeTypesApiV1FlowsNodesTypesGet: function (v, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readNodeTypesApiV1FlowsNodesTypesGet(v, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readNodeTypesApiV1FlowsNodesTypesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Read the last 10 queued jobs and their status.
         * @summary Read Queued
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readQueuedApiV1FlowsFlowIdQGet: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readQueuedApiV1FlowsFlowIdQGet(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readQueuedApiV1FlowsFlowIdQGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get read_flow.
         * @summary Read Subflow
         * @param {string} flowId
         * @param {string} subflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet: function (flowId, subflowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet(flowId, subflowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create subflow.
         * @summary Simulate Subflow
         * @param {string} flowId
         * @param {SubflowCreate} subflowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost: function (flowId, subflowCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost(flowId, subflowCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Run flow.
         * @summary Start Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFlowApiV1FlowsFlowIdStartPost: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.startFlowApiV1FlowsFlowIdStartPost(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.startFlowApiV1FlowsFlowIdStartPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Stops running flow.
         * @summary Stop Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopFlowApiV1FlowsFlowIdStopDelete: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stopFlowApiV1FlowsFlowIdStopDelete(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.stopFlowApiV1FlowsFlowIdStopDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create subflow.
         * @summary Ungroup Subflow
         * @param {string} flowId
         * @param {string} subflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost: function (flowId, subflowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost(flowId, subflowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update flow.
         * @summary Update Flow
         * @param {string} flowId
         * @param {FlowUpdate} flowUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowApiV1FlowsFlowIdPut: function (flowId, flowUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFlowApiV1FlowsFlowIdPut(flowId, flowUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.updateFlowApiV1FlowsFlowIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Node
         * @param {string} flowId
         * @param {string} nodeId
         * @param {NodeUpdate} nodeUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeApiV1FlowsFlowIdNodesNodeIdPut: function (flowId, nodeId, nodeUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateNodeApiV1FlowsFlowIdNodesNodeIdPut(flowId, nodeId, nodeUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.updateNodeApiV1FlowsFlowIdNodesNodeIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Validate flow.
         * @summary Validate Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFlowApiV1FlowsFlowIdValidatePost: function (flowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.validateFlowApiV1FlowsFlowIdValidatePost(flowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FlowsApi.validateFlowApiV1FlowsFlowIdValidatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FlowsApiFp = FlowsApiFp;
/**
 * FlowsApi - factory interface
 * @export
 */
var FlowsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FlowsApiFp)(configuration);
    return {
        /**
         *
         * @summary Add Source Handle
         * @param {string} flowId
         * @param {string} nodeId
         * @param {AddSourceHandle} addSourceHandle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost: function (flowId, nodeId, addSourceHandle, options) {
            return localVarFp.addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost(flowId, nodeId, addSourceHandle, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add Target Handle
         * @param {string} flowId
         * @param {string} nodeId
         * @param {AddTargetHandle} addTargetHandle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost: function (flowId, nodeId, addTargetHandle, options) {
            return localVarFp.addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost(flowId, nodeId, addTargetHandle, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Check Job
         * @param {string} jobId
         * @param {string | null} [flowId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkJobApiV1FlowsJobJobIdGet: function (jobId, flowId, options) {
            return localVarFp.checkJobApiV1FlowsJobJobIdGet(jobId, flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Chrome Resubmit Job
         * @param {string} flowId
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost: function (flowId, jobId, options) {
            return localVarFp.chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost(flowId, jobId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Chrome Submit
         * @param {string} flowId
         * @param {OutputSchema} outputSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeSubmitApiV1FlowsFlowIdChromeSubmitPost: function (flowId, outputSchema, options) {
            return localVarFp.chromeSubmitApiV1FlowsFlowIdChromeSubmitPost(flowId, outputSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Connect nodes.
         * @summary Connect Nodes
         * @param {string} flowId
         * @param {ConnectNodesCreate} connectNodesCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectNodesApiV1FlowsFlowIdConnectPost: function (flowId, connectNodesCreate, options) {
            return localVarFp.connectNodesApiV1FlowsFlowIdConnectPost(flowId, connectNodesCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create flow.
         * @summary Create Flow
         * @param {FlowCreate} flowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowApiV1FlowsPost: function (flowCreate, options) {
            return localVarFp.createFlowApiV1FlowsPost(flowCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Flow Env Var
         * @param {string} flowId
         * @param {FlowEnvVariableCreate} flowEnvVariableCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost: function (flowId, flowEnvVariableCreate, options) {
            return localVarFp.createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost(flowId, flowEnvVariableCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Gsheet
         * @param {string} title
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGsheetApiV1FlowsSheetsPost: function (title, redirectUrl, options) {
            return localVarFp.createGsheetApiV1FlowsSheetsPost(title, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Node
         * @param {string} flowId
         * @param {NodeCreate} nodeCreate
         * @param {string | null} [subflowId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNodeApiV1FlowsFlowIdNodesPost: function (flowId, nodeCreate, subflowId, options) {
            return localVarFp.createNodeApiV1FlowsFlowIdNodesPost(flowId, nodeCreate, subflowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create subflow.
         * @summary Create Subflow
         * @param {string} flowId
         * @param {SubflowCreate} subflowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubflowApiV1FlowsFlowIdSubflowPost: function (flowId, subflowCreate, options) {
            return localVarFp.createSubflowApiV1FlowsFlowIdSubflowPost(flowId, subflowCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create template from flow.
         * @summary Create Template From Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFromFlowApiV1FlowsFlowIdTemplatePost: function (flowId, options) {
            return localVarFp.createTemplateFromFlowApiV1FlowsFlowIdTemplatePost(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Debug Submit
         * @param {string} browserInfo
         * @param {File} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugSubmitApiV1FlowsDebugFormSubmitPost: function (browserInfo, file, options) {
            return localVarFp.debugSubmitApiV1FlowsDebugFormSubmitPost(browserInfo, file, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete flow.
         * @summary Delete Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowApiV1FlowsFlowIdDelete: function (flowId, options) {
            return localVarFp.deleteFlowApiV1FlowsFlowIdDelete(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Flow Env Var
         * @param {string} flowId
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete: function (flowId, envVarId, options) {
            return localVarFp.deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete(flowId, envVarId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Node
         * @param {string} flowId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete: function (flowId, nodeId, options) {
            return localVarFp.deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete(flowId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Demo Hotel Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoHotelHealthApiV1FlowsDemoHotelHealthGet: function (options) {
            return localVarFp.demoHotelHealthApiV1FlowsDemoHotelHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Demo Main Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoMainHealthApiV1FlowsDemoMainHealthGet: function (options) {
            return localVarFp.demoMainHealthApiV1FlowsDemoMainHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Disconnect nodes.
         * @summary Disconnect Nodes
         * @param {string} flowId
         * @param {ConnectNodesCreate} connectNodesCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectNodesApiV1FlowsFlowIdDisconnectDelete: function (flowId, connectNodesCreate, options) {
            return localVarFp.disconnectNodesApiV1FlowsFlowIdDisconnectDelete(flowId, connectNodesCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Duplicate flow.
         * @summary Duplicate Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateFlowApiV1FlowsDuplicateFlowIdPost: function (flowId, options) {
            return localVarFp.duplicateFlowApiV1FlowsDuplicateFlowIdPost(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Exec example data.
         * @summary Exec Example Data
         * @param {string} flowId
         * @param {string} data
         * @param {Array<File>} [files]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        execExampleDataApiV1FlowsFlowIdExamplePost: function (flowId, data, files, options) {
            return localVarFp.execExampleDataApiV1FlowsFlowIdExamplePost(flowId, data, files, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Form Json
         * @param {string} flowId
         * @param {string | null} [previousRunId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formJsonApiV1FlowsFlowIdFormSchemaGet: function (flowId, previousRunId, options) {
            return localVarFp.formJsonApiV1FlowsFlowIdFormSchemaGet(flowId, previousRunId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Form Submit
         * @param {string} flowId
         * @param {string} formData
         * @param {Array<File>} [files]
         * @param {string | null} [previousRunId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formSubmitApiV1FlowsFlowIdFormSubmitPost: function (flowId, formData, files, previousRunId, options) {
            return localVarFp.formSubmitApiV1FlowsFlowIdFormSubmitPost(flowId, formData, files, previousRunId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Form Widget Code
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formWidgetCodeApiV1FlowsFlowIdFormCodeGet: function (flowId, options) {
            return localVarFp.formWidgetCodeApiV1FlowsFlowIdFormCodeGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get template from flow.
         * @summary Get Template From Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFromFlowApiV1FlowsFlowIdTemplateGet: function (flowId, options) {
            return localVarFp.getTemplateFromFlowApiV1FlowsFlowIdTemplateGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mic Submit
         * @param {string} flowId
         * @param {File} recording
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        micSubmitApiV1FlowsFlowIdMicSubmitPost: function (flowId, recording, options) {
            return localVarFp.micSubmitApiV1FlowsFlowIdMicSubmitPost(flowId, recording, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Preview Form Json
         * @param {PreviewFormRequest} previewFormRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost: function (previewFormRequest, options) {
            return localVarFp.previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost(previewFormRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get example schema.
         * @summary Read Example Schema
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet: function (flowId, options) {
            return localVarFp.readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get read_flow.
         * @summary Read Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowApiV1FlowsFlowIdGet: function (flowId, options) {
            return localVarFp.readFlowApiV1FlowsFlowIdGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Flow Env Vars
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet: function (flowId, options) {
            return localVarFp.readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get read_flow.
         * @summary Read Flow Json
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowJsonApiV1FlowsFlowIdJsonGet: function (flowId, options) {
            return localVarFp.readFlowJsonApiV1FlowsFlowIdJsonGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Flow Settings
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFlowSettingsApiV1FlowsFlowIdSettingsGet: function (flowId, options) {
            return localVarFp.readFlowSettingsApiV1FlowsFlowIdSettingsGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get issues.
         * @summary Read Issues
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIssuesApiV1FlowsFlowIdIssuesGet: function (flowId, options) {
            return localVarFp.readIssuesApiV1FlowsFlowIdIssuesGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1FlowsMeGet: function (options) {
            return localVarFp.readMeApiV1FlowsMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user\'s flows.
         * @summary Read Me Chrome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeChromeApiV1FlowsMeChromeGet: function (options) {
            return localVarFp.readMeChromeApiV1FlowsMeChromeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Node Types
         * @param {string} [v]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNodeTypesApiV1FlowsNodesTypesGet: function (v, options) {
            return localVarFp.readNodeTypesApiV1FlowsNodesTypesGet(v, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Read the last 10 queued jobs and their status.
         * @summary Read Queued
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readQueuedApiV1FlowsFlowIdQGet: function (flowId, options) {
            return localVarFp.readQueuedApiV1FlowsFlowIdQGet(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get read_flow.
         * @summary Read Subflow
         * @param {string} flowId
         * @param {string} subflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet: function (flowId, subflowId, options) {
            return localVarFp.readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet(flowId, subflowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create subflow.
         * @summary Simulate Subflow
         * @param {string} flowId
         * @param {SubflowCreate} subflowCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost: function (flowId, subflowCreate, options) {
            return localVarFp.simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost(flowId, subflowCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Run flow.
         * @summary Start Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFlowApiV1FlowsFlowIdStartPost: function (flowId, options) {
            return localVarFp.startFlowApiV1FlowsFlowIdStartPost(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Stops running flow.
         * @summary Stop Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopFlowApiV1FlowsFlowIdStopDelete: function (flowId, options) {
            return localVarFp.stopFlowApiV1FlowsFlowIdStopDelete(flowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create subflow.
         * @summary Ungroup Subflow
         * @param {string} flowId
         * @param {string} subflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost: function (flowId, subflowId, options) {
            return localVarFp.ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost(flowId, subflowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update flow.
         * @summary Update Flow
         * @param {string} flowId
         * @param {FlowUpdate} flowUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowApiV1FlowsFlowIdPut: function (flowId, flowUpdate, options) {
            return localVarFp.updateFlowApiV1FlowsFlowIdPut(flowId, flowUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Node
         * @param {string} flowId
         * @param {string} nodeId
         * @param {NodeUpdate} nodeUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeApiV1FlowsFlowIdNodesNodeIdPut: function (flowId, nodeId, nodeUpdate, options) {
            return localVarFp.updateNodeApiV1FlowsFlowIdNodesNodeIdPut(flowId, nodeId, nodeUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Validate flow.
         * @summary Validate Flow
         * @param {string} flowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFlowApiV1FlowsFlowIdValidatePost: function (flowId, options) {
            return localVarFp.validateFlowApiV1FlowsFlowIdValidatePost(flowId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FlowsApiFactory = FlowsApiFactory;
/**
 * FlowsApi - object-oriented interface
 * @export
 * @class FlowsApi
 * @extends {BaseAPI}
 */
var FlowsApi = /** @class */ (function (_super) {
    __extends(FlowsApi, _super);
    function FlowsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Add Source Handle
     * @param {string} flowId
     * @param {string} nodeId
     * @param {AddSourceHandle} addSourceHandle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost = function (flowId, nodeId, addSourceHandle, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).addSourceHandleApiV1FlowsFlowIdNodesAddSourceHandlePost(flowId, nodeId, addSourceHandle, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add Target Handle
     * @param {string} flowId
     * @param {string} nodeId
     * @param {AddTargetHandle} addTargetHandle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost = function (flowId, nodeId, addTargetHandle, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).addTargetHandleApiV1FlowsFlowIdNodesAddTargetHandlePost(flowId, nodeId, addTargetHandle, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Check Job
     * @param {string} jobId
     * @param {string | null} [flowId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.checkJobApiV1FlowsJobJobIdGet = function (jobId, flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).checkJobApiV1FlowsJobJobIdGet(jobId, flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Chrome Resubmit Job
     * @param {string} flowId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost = function (flowId, jobId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).chromeResubmitJobApiV1FlowsFlowIdChromeResubmitJobIdPost(flowId, jobId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Chrome Submit
     * @param {string} flowId
     * @param {OutputSchema} outputSchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.chromeSubmitApiV1FlowsFlowIdChromeSubmitPost = function (flowId, outputSchema, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).chromeSubmitApiV1FlowsFlowIdChromeSubmitPost(flowId, outputSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Connect nodes.
     * @summary Connect Nodes
     * @param {string} flowId
     * @param {ConnectNodesCreate} connectNodesCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.connectNodesApiV1FlowsFlowIdConnectPost = function (flowId, connectNodesCreate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).connectNodesApiV1FlowsFlowIdConnectPost(flowId, connectNodesCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create flow.
     * @summary Create Flow
     * @param {FlowCreate} flowCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.createFlowApiV1FlowsPost = function (flowCreate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).createFlowApiV1FlowsPost(flowCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Flow Env Var
     * @param {string} flowId
     * @param {FlowEnvVariableCreate} flowEnvVariableCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost = function (flowId, flowEnvVariableCreate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).createFlowEnvVarApiV1FlowsFlowIdEnvVarsPost(flowId, flowEnvVariableCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Gsheet
     * @param {string} title
     * @param {string} redirectUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.createGsheetApiV1FlowsSheetsPost = function (title, redirectUrl, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).createGsheetApiV1FlowsSheetsPost(title, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Node
     * @param {string} flowId
     * @param {NodeCreate} nodeCreate
     * @param {string | null} [subflowId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.createNodeApiV1FlowsFlowIdNodesPost = function (flowId, nodeCreate, subflowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).createNodeApiV1FlowsFlowIdNodesPost(flowId, nodeCreate, subflowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create subflow.
     * @summary Create Subflow
     * @param {string} flowId
     * @param {SubflowCreate} subflowCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.createSubflowApiV1FlowsFlowIdSubflowPost = function (flowId, subflowCreate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).createSubflowApiV1FlowsFlowIdSubflowPost(flowId, subflowCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create template from flow.
     * @summary Create Template From Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.createTemplateFromFlowApiV1FlowsFlowIdTemplatePost = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).createTemplateFromFlowApiV1FlowsFlowIdTemplatePost(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Debug Submit
     * @param {string} browserInfo
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.debugSubmitApiV1FlowsDebugFormSubmitPost = function (browserInfo, file, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).debugSubmitApiV1FlowsDebugFormSubmitPost(browserInfo, file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete flow.
     * @summary Delete Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.deleteFlowApiV1FlowsFlowIdDelete = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).deleteFlowApiV1FlowsFlowIdDelete(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Flow Env Var
     * @param {string} flowId
     * @param {string} envVarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete = function (flowId, envVarId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).deleteFlowEnvVarApiV1FlowsFlowIdEnvVarsEnvVarIdDelete(flowId, envVarId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Node
     * @param {string} flowId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete = function (flowId, nodeId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).deleteNodeApiV1FlowsFlowIdNodesNodeIdDelete(flowId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Demo Hotel Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.demoHotelHealthApiV1FlowsDemoHotelHealthGet = function (options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).demoHotelHealthApiV1FlowsDemoHotelHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Demo Main Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.demoMainHealthApiV1FlowsDemoMainHealthGet = function (options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).demoMainHealthApiV1FlowsDemoMainHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Disconnect nodes.
     * @summary Disconnect Nodes
     * @param {string} flowId
     * @param {ConnectNodesCreate} connectNodesCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.disconnectNodesApiV1FlowsFlowIdDisconnectDelete = function (flowId, connectNodesCreate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).disconnectNodesApiV1FlowsFlowIdDisconnectDelete(flowId, connectNodesCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Duplicate flow.
     * @summary Duplicate Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.duplicateFlowApiV1FlowsDuplicateFlowIdPost = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).duplicateFlowApiV1FlowsDuplicateFlowIdPost(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Exec example data.
     * @summary Exec Example Data
     * @param {string} flowId
     * @param {string} data
     * @param {Array<File>} [files]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.execExampleDataApiV1FlowsFlowIdExamplePost = function (flowId, data, files, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).execExampleDataApiV1FlowsFlowIdExamplePost(flowId, data, files, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Form Json
     * @param {string} flowId
     * @param {string | null} [previousRunId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.formJsonApiV1FlowsFlowIdFormSchemaGet = function (flowId, previousRunId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).formJsonApiV1FlowsFlowIdFormSchemaGet(flowId, previousRunId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Form Submit
     * @param {string} flowId
     * @param {string} formData
     * @param {Array<File>} [files]
     * @param {string | null} [previousRunId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.formSubmitApiV1FlowsFlowIdFormSubmitPost = function (flowId, formData, files, previousRunId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).formSubmitApiV1FlowsFlowIdFormSubmitPost(flowId, formData, files, previousRunId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Form Widget Code
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.formWidgetCodeApiV1FlowsFlowIdFormCodeGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).formWidgetCodeApiV1FlowsFlowIdFormCodeGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get template from flow.
     * @summary Get Template From Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.getTemplateFromFlowApiV1FlowsFlowIdTemplateGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).getTemplateFromFlowApiV1FlowsFlowIdTemplateGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mic Submit
     * @param {string} flowId
     * @param {File} recording
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.micSubmitApiV1FlowsFlowIdMicSubmitPost = function (flowId, recording, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).micSubmitApiV1FlowsFlowIdMicSubmitPost(flowId, recording, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Preview Form Json
     * @param {PreviewFormRequest} previewFormRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost = function (previewFormRequest, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).previewFormJsonApiV1FlowsFlowIdNodesPreviewFormPost(previewFormRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get example schema.
     * @summary Read Example Schema
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readExampleSchemaApiV1FlowsFlowIdExampleSchemaGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get read_flow.
     * @summary Read Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readFlowApiV1FlowsFlowIdGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readFlowApiV1FlowsFlowIdGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Flow Env Vars
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readFlowEnvVarsApiV1FlowsFlowIdEnvVarsGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get read_flow.
     * @summary Read Flow Json
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readFlowJsonApiV1FlowsFlowIdJsonGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readFlowJsonApiV1FlowsFlowIdJsonGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Flow Settings
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readFlowSettingsApiV1FlowsFlowIdSettingsGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readFlowSettingsApiV1FlowsFlowIdSettingsGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get issues.
     * @summary Read Issues
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readIssuesApiV1FlowsFlowIdIssuesGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readIssuesApiV1FlowsFlowIdIssuesGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user\'s flows.
     * @summary Read Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readMeApiV1FlowsMeGet = function (options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readMeApiV1FlowsMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user\'s flows.
     * @summary Read Me Chrome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readMeChromeApiV1FlowsMeChromeGet = function (options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readMeChromeApiV1FlowsMeChromeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Node Types
     * @param {string} [v]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readNodeTypesApiV1FlowsNodesTypesGet = function (v, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readNodeTypesApiV1FlowsNodesTypesGet(v, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Read the last 10 queued jobs and their status.
     * @summary Read Queued
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readQueuedApiV1FlowsFlowIdQGet = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readQueuedApiV1FlowsFlowIdQGet(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get read_flow.
     * @summary Read Subflow
     * @param {string} flowId
     * @param {string} subflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet = function (flowId, subflowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).readSubflowApiV1FlowsFlowIdSubflowSubflowIdGet(flowId, subflowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create subflow.
     * @summary Simulate Subflow
     * @param {string} flowId
     * @param {SubflowCreate} subflowCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost = function (flowId, subflowCreate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).simulateSubflowApiV1FlowsFlowIdSubflowSimulatePost(flowId, subflowCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Run flow.
     * @summary Start Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.startFlowApiV1FlowsFlowIdStartPost = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).startFlowApiV1FlowsFlowIdStartPost(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Stops running flow.
     * @summary Stop Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.stopFlowApiV1FlowsFlowIdStopDelete = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).stopFlowApiV1FlowsFlowIdStopDelete(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create subflow.
     * @summary Ungroup Subflow
     * @param {string} flowId
     * @param {string} subflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost = function (flowId, subflowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).ungroupSubflowApiV1FlowsFlowIdSubflowSubflowIdPost(flowId, subflowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update flow.
     * @summary Update Flow
     * @param {string} flowId
     * @param {FlowUpdate} flowUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.updateFlowApiV1FlowsFlowIdPut = function (flowId, flowUpdate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).updateFlowApiV1FlowsFlowIdPut(flowId, flowUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Node
     * @param {string} flowId
     * @param {string} nodeId
     * @param {NodeUpdate} nodeUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.updateNodeApiV1FlowsFlowIdNodesNodeIdPut = function (flowId, nodeId, nodeUpdate, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).updateNodeApiV1FlowsFlowIdNodesNodeIdPut(flowId, nodeId, nodeUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Validate flow.
     * @summary Validate Flow
     * @param {string} flowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    FlowsApi.prototype.validateFlowApiV1FlowsFlowIdValidatePost = function (flowId, options) {
        var _this = this;
        return (0, exports.FlowsApiFp)(this.configuration).validateFlowApiV1FlowsFlowIdValidatePost(flowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FlowsApi;
}(base_1.BaseAPI));
exports.FlowsApi = FlowsApi;
/**
 * HealthApi - axios parameter creator
 * @export
 */
var HealthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthApiV1AdminHealthGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthApiAxiosParamCreator = HealthApiAxiosParamCreator;
/**
 * HealthApi - functional programming interface
 * @export
 */
var HealthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthApiV1AdminHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthApiV1AdminHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HealthApi.healthApiV1AdminHealthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.HealthApiFp = HealthApiFp;
/**
 * HealthApi - factory interface
 * @export
 */
var HealthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthApiFp)(configuration);
    return {
        /**
         *
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthApiV1AdminHealthGet: function (options) {
            return localVarFp.healthApiV1AdminHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthApiFactory = HealthApiFactory;
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
var HealthApi = /** @class */ (function (_super) {
    __extends(HealthApi, _super);
    function HealthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    HealthApi.prototype.healthApiV1AdminHealthGet = function (options) {
        var _this = this;
        return (0, exports.HealthApiFp)(this.configuration).healthApiV1AdminHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthApi;
}(base_1.BaseAPI));
exports.HealthApi = HealthApi;
/**
 * MetaApi - axios parameter creator
 * @export
 */
var MetaApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Deauthorize Insta
         * @param {File} signedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deauthorizeInstaApiV1MetaDeauthorizePost: function (signedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([signedRequest_1], args_1, true), void 0, function (signedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'signedRequest' is not null or undefined
                    (0, common_1.assertParamExists)('deauthorizeInstaApiV1MetaDeauthorizePost', 'signedRequest', signedRequest);
                    localVarPath = "/api/v1/meta/deauthorize";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (signedRequest !== undefined) {
                        localVarFormParams.set('signed_request', signedRequest);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete data handler.
         * @summary Delete Data
         * @param {File} signedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataApiV1MetaDeleteDataPost: function (signedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([signedRequest_1], args_1, true), void 0, function (signedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'signedRequest' is not null or undefined
                    (0, common_1.assertParamExists)('deleteDataApiV1MetaDeleteDataPost', 'signedRequest', signedRequest);
                    localVarPath = "/api/v1/meta/delete-data";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (signedRequest !== undefined) {
                        localVarFormParams.set('signed_request', signedRequest);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Escalate Instagram DM.
         * @summary Escalate
         * @param {string} recipientId
         * @param {EscalationCreate} escalationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateApiV1MetaInstagramNewDmsEscalationPost: function (recipientId_1, escalationCreate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([recipientId_1, escalationCreate_1], args_1, true), void 0, function (recipientId, escalationCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'recipientId' is not null or undefined
                            (0, common_1.assertParamExists)('escalateApiV1MetaInstagramNewDmsEscalationPost', 'recipientId', recipientId);
                            // verify required parameter 'escalationCreate' is not null or undefined
                            (0, common_1.assertParamExists)('escalateApiV1MetaInstagramNewDmsEscalationPost', 'escalationCreate', escalationCreate);
                            localVarPath = "/api/v1/meta/instagram/new-dms/escalation";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (recipientId !== undefined) {
                                localVarQueryParameter['recipient_id'] = recipientId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(escalationCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Instagram Conversation
         * @param {string} recipientId
         * @param {string} senderId
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstagramConversationApiV1MetaInstagramConversationGet: function (recipientId_1, senderId_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([recipientId_1, senderId_1, limit_1], args_1, true), void 0, function (recipientId, senderId, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'recipientId' is not null or undefined
                            (0, common_1.assertParamExists)('getInstagramConversationApiV1MetaInstagramConversationGet', 'recipientId', recipientId);
                            // verify required parameter 'senderId' is not null or undefined
                            (0, common_1.assertParamExists)('getInstagramConversationApiV1MetaInstagramConversationGet', 'senderId', senderId);
                            localVarPath = "/api/v1/meta/instagram/conversation";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (recipientId !== undefined) {
                                localVarQueryParameter['recipient_id'] = recipientId;
                            }
                            if (senderId !== undefined) {
                                localVarQueryParameter['sender_id'] = senderId;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get new Instagram DM.
         * @summary Get Instagram New Dms
         * @param {string} recipientId
         * @param {number} [limitHistory]
         * @param {number} [delay]
         * @param {number} [after]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstagramNewDmsApiV1MetaInstagramNewDmsGet: function (recipientId_1, limitHistory_1, delay_1, after_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([recipientId_1, limitHistory_1, delay_1, after_1], args_1, true), void 0, function (recipientId, limitHistory, delay, after, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'recipientId' is not null or undefined
                            (0, common_1.assertParamExists)('getInstagramNewDmsApiV1MetaInstagramNewDmsGet', 'recipientId', recipientId);
                            localVarPath = "/api/v1/meta/instagram/new-dms";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (recipientId !== undefined) {
                                localVarQueryParameter['recipient_id'] = recipientId;
                            }
                            if (limitHistory !== undefined) {
                                localVarQueryParameter['limit_history'] = limitHistory;
                            }
                            if (delay !== undefined) {
                                localVarQueryParameter['delay'] = delay;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark Processed
         * @param {string} recipientId
         * @param {string} senderId
         * @param {number} lastProcessedTimestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markProcessedApiV1MetaInstagramNewDmsProcessedPost: function (recipientId_1, senderId_1, lastProcessedTimestamp_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([recipientId_1, senderId_1, lastProcessedTimestamp_1], args_1, true), void 0, function (recipientId, senderId, lastProcessedTimestamp, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'recipientId' is not null or undefined
                            (0, common_1.assertParamExists)('markProcessedApiV1MetaInstagramNewDmsProcessedPost', 'recipientId', recipientId);
                            // verify required parameter 'senderId' is not null or undefined
                            (0, common_1.assertParamExists)('markProcessedApiV1MetaInstagramNewDmsProcessedPost', 'senderId', senderId);
                            // verify required parameter 'lastProcessedTimestamp' is not null or undefined
                            (0, common_1.assertParamExists)('markProcessedApiV1MetaInstagramNewDmsProcessedPost', 'lastProcessedTimestamp', lastProcessedTimestamp);
                            localVarPath = "/api/v1/meta/instagram/new-dms/processed";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (recipientId !== undefined) {
                                localVarQueryParameter['recipient_id'] = recipientId;
                            }
                            if (senderId !== undefined) {
                                localVarQueryParameter['sender_id'] = senderId;
                            }
                            if (lastProcessedTimestamp !== undefined) {
                                localVarQueryParameter['last_processed_timestamp'] = lastProcessedTimestamp;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get escalation.
         * @summary Read Escalation
         * @param {string} escalationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet: function (escalationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([escalationId_1], args_1, true), void 0, function (escalationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'escalationId' is not null or undefined
                            (0, common_1.assertParamExists)('readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet', 'escalationId', escalationId);
                            localVarPath = "/api/v1/meta/instagram/new-dms/escalation/{escalation_id}"
                                .replace("{".concat("escalation_id", "}"), encodeURIComponent(String(escalationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get escalations.
         * @summary Read Escalations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/meta/instagram/new-dms/escalation/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Resolve Instagram DM escalation.
         * @summary Resolve Escalation
         * @param {string} escalationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveEscalationApiV1MetaInstagramNewDmsResolvePost: function (escalationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([escalationId_1], args_1, true), void 0, function (escalationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'escalationId' is not null or undefined
                            (0, common_1.assertParamExists)('resolveEscalationApiV1MetaInstagramNewDmsResolvePost', 'escalationId', escalationId);
                            localVarPath = "/api/v1/meta/instagram/new-dms/resolve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (escalationId !== undefined) {
                                localVarQueryParameter['escalation_id'] = escalationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send Dm
         * @param {SendDmCreate} sendDmCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDmApiV1MetaInstagramConversationPost: function (sendDmCreate_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sendDmCreate_1], args_1, true), void 0, function (sendDmCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'sendDmCreate' is not null or undefined
                            (0, common_1.assertParamExists)('sendDmApiV1MetaInstagramConversationPost', 'sendDmCreate', sendDmCreate);
                            localVarPath = "/api/v1/meta/instagram/conversation";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendDmCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * On webook verification META_VERIFY_TOKEN has to match the token at the configuration and send back \"hub.challenge\" as success.
         * @summary Verify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyApiV1MetaWebhookGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/meta/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Messages handler.
         * @summary Webhook
         * @param {WebhookRequestData} webhookRequestData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookApiV1MetaWebhookPost: function (webhookRequestData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([webhookRequestData_1], args_1, true), void 0, function (webhookRequestData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'webhookRequestData' is not null or undefined
                    (0, common_1.assertParamExists)('webhookApiV1MetaWebhookPost', 'webhookRequestData', webhookRequestData);
                    localVarPath = "/api/v1/meta/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(webhookRequestData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MetaApiAxiosParamCreator = MetaApiAxiosParamCreator;
/**
 * MetaApi - functional programming interface
 * @export
 */
var MetaApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MetaApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Deauthorize Insta
         * @param {File} signedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deauthorizeInstaApiV1MetaDeauthorizePost: function (signedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deauthorizeInstaApiV1MetaDeauthorizePost(signedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.deauthorizeInstaApiV1MetaDeauthorizePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete data handler.
         * @summary Delete Data
         * @param {File} signedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataApiV1MetaDeleteDataPost: function (signedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDataApiV1MetaDeleteDataPost(signedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.deleteDataApiV1MetaDeleteDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Escalate Instagram DM.
         * @summary Escalate
         * @param {string} recipientId
         * @param {EscalationCreate} escalationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateApiV1MetaInstagramNewDmsEscalationPost: function (recipientId, escalationCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.escalateApiV1MetaInstagramNewDmsEscalationPost(recipientId, escalationCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.escalateApiV1MetaInstagramNewDmsEscalationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Instagram Conversation
         * @param {string} recipientId
         * @param {string} senderId
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstagramConversationApiV1MetaInstagramConversationGet: function (recipientId, senderId, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInstagramConversationApiV1MetaInstagramConversationGet(recipientId, senderId, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.getInstagramConversationApiV1MetaInstagramConversationGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get new Instagram DM.
         * @summary Get Instagram New Dms
         * @param {string} recipientId
         * @param {number} [limitHistory]
         * @param {number} [delay]
         * @param {number} [after]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstagramNewDmsApiV1MetaInstagramNewDmsGet: function (recipientId, limitHistory, delay, after, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInstagramNewDmsApiV1MetaInstagramNewDmsGet(recipientId, limitHistory, delay, after, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.getInstagramNewDmsApiV1MetaInstagramNewDmsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark Processed
         * @param {string} recipientId
         * @param {string} senderId
         * @param {number} lastProcessedTimestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markProcessedApiV1MetaInstagramNewDmsProcessedPost: function (recipientId, senderId, lastProcessedTimestamp, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.markProcessedApiV1MetaInstagramNewDmsProcessedPost(recipientId, senderId, lastProcessedTimestamp, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.markProcessedApiV1MetaInstagramNewDmsProcessedPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get escalation.
         * @summary Read Escalation
         * @param {string} escalationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet: function (escalationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet(escalationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get escalations.
         * @summary Read Escalations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Resolve Instagram DM escalation.
         * @summary Resolve Escalation
         * @param {string} escalationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveEscalationApiV1MetaInstagramNewDmsResolvePost: function (escalationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resolveEscalationApiV1MetaInstagramNewDmsResolvePost(escalationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.resolveEscalationApiV1MetaInstagramNewDmsResolvePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send Dm
         * @param {SendDmCreate} sendDmCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDmApiV1MetaInstagramConversationPost: function (sendDmCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendDmApiV1MetaInstagramConversationPost(sendDmCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.sendDmApiV1MetaInstagramConversationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * On webook verification META_VERIFY_TOKEN has to match the token at the configuration and send back \"hub.challenge\" as success.
         * @summary Verify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyApiV1MetaWebhookGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.verifyApiV1MetaWebhookGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.verifyApiV1MetaWebhookGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Messages handler.
         * @summary Webhook
         * @param {WebhookRequestData} webhookRequestData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookApiV1MetaWebhookPost: function (webhookRequestData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhookApiV1MetaWebhookPost(webhookRequestData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetaApi.webhookApiV1MetaWebhookPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.MetaApiFp = MetaApiFp;
/**
 * MetaApi - factory interface
 * @export
 */
var MetaApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MetaApiFp)(configuration);
    return {
        /**
         *
         * @summary Deauthorize Insta
         * @param {File} signedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deauthorizeInstaApiV1MetaDeauthorizePost: function (signedRequest, options) {
            return localVarFp.deauthorizeInstaApiV1MetaDeauthorizePost(signedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete data handler.
         * @summary Delete Data
         * @param {File} signedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataApiV1MetaDeleteDataPost: function (signedRequest, options) {
            return localVarFp.deleteDataApiV1MetaDeleteDataPost(signedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Escalate Instagram DM.
         * @summary Escalate
         * @param {string} recipientId
         * @param {EscalationCreate} escalationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateApiV1MetaInstagramNewDmsEscalationPost: function (recipientId, escalationCreate, options) {
            return localVarFp.escalateApiV1MetaInstagramNewDmsEscalationPost(recipientId, escalationCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Instagram Conversation
         * @param {string} recipientId
         * @param {string} senderId
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstagramConversationApiV1MetaInstagramConversationGet: function (recipientId, senderId, limit, options) {
            return localVarFp.getInstagramConversationApiV1MetaInstagramConversationGet(recipientId, senderId, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get new Instagram DM.
         * @summary Get Instagram New Dms
         * @param {string} recipientId
         * @param {number} [limitHistory]
         * @param {number} [delay]
         * @param {number} [after]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstagramNewDmsApiV1MetaInstagramNewDmsGet: function (recipientId, limitHistory, delay, after, options) {
            return localVarFp.getInstagramNewDmsApiV1MetaInstagramNewDmsGet(recipientId, limitHistory, delay, after, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark Processed
         * @param {string} recipientId
         * @param {string} senderId
         * @param {number} lastProcessedTimestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markProcessedApiV1MetaInstagramNewDmsProcessedPost: function (recipientId, senderId, lastProcessedTimestamp, options) {
            return localVarFp.markProcessedApiV1MetaInstagramNewDmsProcessedPost(recipientId, senderId, lastProcessedTimestamp, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get escalation.
         * @summary Read Escalation
         * @param {string} escalationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet: function (escalationId, options) {
            return localVarFp.readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet(escalationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get escalations.
         * @summary Read Escalations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet: function (options) {
            return localVarFp.readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Resolve Instagram DM escalation.
         * @summary Resolve Escalation
         * @param {string} escalationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveEscalationApiV1MetaInstagramNewDmsResolvePost: function (escalationId, options) {
            return localVarFp.resolveEscalationApiV1MetaInstagramNewDmsResolvePost(escalationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send Dm
         * @param {SendDmCreate} sendDmCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDmApiV1MetaInstagramConversationPost: function (sendDmCreate, options) {
            return localVarFp.sendDmApiV1MetaInstagramConversationPost(sendDmCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * On webook verification META_VERIFY_TOKEN has to match the token at the configuration and send back \"hub.challenge\" as success.
         * @summary Verify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyApiV1MetaWebhookGet: function (options) {
            return localVarFp.verifyApiV1MetaWebhookGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Messages handler.
         * @summary Webhook
         * @param {WebhookRequestData} webhookRequestData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookApiV1MetaWebhookPost: function (webhookRequestData, options) {
            return localVarFp.webhookApiV1MetaWebhookPost(webhookRequestData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MetaApiFactory = MetaApiFactory;
/**
 * MetaApi - object-oriented interface
 * @export
 * @class MetaApi
 * @extends {BaseAPI}
 */
var MetaApi = /** @class */ (function (_super) {
    __extends(MetaApi, _super);
    function MetaApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Deauthorize Insta
     * @param {File} signedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.deauthorizeInstaApiV1MetaDeauthorizePost = function (signedRequest, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).deauthorizeInstaApiV1MetaDeauthorizePost(signedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete data handler.
     * @summary Delete Data
     * @param {File} signedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.deleteDataApiV1MetaDeleteDataPost = function (signedRequest, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).deleteDataApiV1MetaDeleteDataPost(signedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Escalate Instagram DM.
     * @summary Escalate
     * @param {string} recipientId
     * @param {EscalationCreate} escalationCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.escalateApiV1MetaInstagramNewDmsEscalationPost = function (recipientId, escalationCreate, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).escalateApiV1MetaInstagramNewDmsEscalationPost(recipientId, escalationCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Instagram Conversation
     * @param {string} recipientId
     * @param {string} senderId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.getInstagramConversationApiV1MetaInstagramConversationGet = function (recipientId, senderId, limit, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).getInstagramConversationApiV1MetaInstagramConversationGet(recipientId, senderId, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get new Instagram DM.
     * @summary Get Instagram New Dms
     * @param {string} recipientId
     * @param {number} [limitHistory]
     * @param {number} [delay]
     * @param {number} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.getInstagramNewDmsApiV1MetaInstagramNewDmsGet = function (recipientId, limitHistory, delay, after, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).getInstagramNewDmsApiV1MetaInstagramNewDmsGet(recipientId, limitHistory, delay, after, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark Processed
     * @param {string} recipientId
     * @param {string} senderId
     * @param {number} lastProcessedTimestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.markProcessedApiV1MetaInstagramNewDmsProcessedPost = function (recipientId, senderId, lastProcessedTimestamp, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).markProcessedApiV1MetaInstagramNewDmsProcessedPost(recipientId, senderId, lastProcessedTimestamp, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get escalation.
     * @summary Read Escalation
     * @param {string} escalationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet = function (escalationId, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).readEscalationApiV1MetaInstagramNewDmsEscalationEscalationIdGet(escalationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get escalations.
     * @summary Read Escalations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet = function (options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).readEscalationsApiV1MetaInstagramNewDmsEscalationMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Resolve Instagram DM escalation.
     * @summary Resolve Escalation
     * @param {string} escalationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.resolveEscalationApiV1MetaInstagramNewDmsResolvePost = function (escalationId, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).resolveEscalationApiV1MetaInstagramNewDmsResolvePost(escalationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send Dm
     * @param {SendDmCreate} sendDmCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.sendDmApiV1MetaInstagramConversationPost = function (sendDmCreate, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).sendDmApiV1MetaInstagramConversationPost(sendDmCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * On webook verification META_VERIFY_TOKEN has to match the token at the configuration and send back \"hub.challenge\" as success.
     * @summary Verify
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.verifyApiV1MetaWebhookGet = function (options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).verifyApiV1MetaWebhookGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Messages handler.
     * @summary Webhook
     * @param {WebhookRequestData} webhookRequestData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    MetaApi.prototype.webhookApiV1MetaWebhookPost = function (webhookRequestData, options) {
        var _this = this;
        return (0, exports.MetaApiFp)(this.configuration).webhookApiV1MetaWebhookPost(webhookRequestData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MetaApi;
}(base_1.BaseAPI));
exports.MetaApi = MetaApi;
/**
 * MetricsApi - axios parameter creator
 * @export
 */
var MetricsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get metrics summary.
         * @summary Get Metrics Summary Admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetricsSummaryAdminApiV1MetricsSummaryGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/metrics/summary";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MetricsApiAxiosParamCreator = MetricsApiAxiosParamCreator;
/**
 * MetricsApi - functional programming interface
 * @export
 */
var MetricsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MetricsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get metrics summary.
         * @summary Get Metrics Summary Admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetricsSummaryAdminApiV1MetricsSummaryGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMetricsSummaryAdminApiV1MetricsSummaryGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MetricsApi.getMetricsSummaryAdminApiV1MetricsSummaryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.MetricsApiFp = MetricsApiFp;
/**
 * MetricsApi - factory interface
 * @export
 */
var MetricsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MetricsApiFp)(configuration);
    return {
        /**
         * Get metrics summary.
         * @summary Get Metrics Summary Admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetricsSummaryAdminApiV1MetricsSummaryGet: function (options) {
            return localVarFp.getMetricsSummaryAdminApiV1MetricsSummaryGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MetricsApiFactory = MetricsApiFactory;
/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
var MetricsApi = /** @class */ (function (_super) {
    __extends(MetricsApi, _super);
    function MetricsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get metrics summary.
     * @summary Get Metrics Summary Admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    MetricsApi.prototype.getMetricsSummaryAdminApiV1MetricsSummaryGet = function (options) {
        var _this = this;
        return (0, exports.MetricsApiFp)(this.configuration).getMetricsSummaryAdminApiV1MetricsSummaryGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MetricsApi;
}(base_1.BaseAPI));
exports.MetricsApi = MetricsApi;
/**
 * NotifsApi - axios parameter creator
 * @export
 */
var NotifsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete all notifs for current user.
         * @summary Delete Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeApiV1NotifsMeDelete: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/notifs/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a notif.
         * @summary Delete Notif
         * @param {string} notifId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotifApiV1NotifsNotifIdDelete: function (notifId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([notifId_1], args_1, true), void 0, function (notifId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'notifId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteNotifApiV1NotifsNotifIdDelete', 'notifId', notifId);
                            localVarPath = "/api/v1/notifs/{notif_id}"
                                .replace("{".concat("notif_id", "}"), encodeURIComponent(String(notifId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get current user.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1NotifsMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/notifs/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.NotifsApiAxiosParamCreator = NotifsApiAxiosParamCreator;
/**
 * NotifsApi - functional programming interface
 * @export
 */
var NotifsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NotifsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete all notifs for current user.
         * @summary Delete Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeApiV1NotifsMeDelete: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMeApiV1NotifsMeDelete(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotifsApi.deleteMeApiV1NotifsMeDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a notif.
         * @summary Delete Notif
         * @param {string} notifId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotifApiV1NotifsNotifIdDelete: function (notifId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteNotifApiV1NotifsNotifIdDelete(notifId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotifsApi.deleteNotifApiV1NotifsNotifIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1NotifsMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readMeApiV1NotifsMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotifsApi.readMeApiV1NotifsMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.NotifsApiFp = NotifsApiFp;
/**
 * NotifsApi - factory interface
 * @export
 */
var NotifsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NotifsApiFp)(configuration);
    return {
        /**
         * Delete all notifs for current user.
         * @summary Delete Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeApiV1NotifsMeDelete: function (options) {
            return localVarFp.deleteMeApiV1NotifsMeDelete(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a notif.
         * @summary Delete Notif
         * @param {string} notifId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotifApiV1NotifsNotifIdDelete: function (notifId, options) {
            return localVarFp.deleteNotifApiV1NotifsNotifIdDelete(notifId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1NotifsMeGet: function (options) {
            return localVarFp.readMeApiV1NotifsMeGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NotifsApiFactory = NotifsApiFactory;
/**
 * NotifsApi - object-oriented interface
 * @export
 * @class NotifsApi
 * @extends {BaseAPI}
 */
var NotifsApi = /** @class */ (function (_super) {
    __extends(NotifsApi, _super);
    function NotifsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete all notifs for current user.
     * @summary Delete Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotifsApi
     */
    NotifsApi.prototype.deleteMeApiV1NotifsMeDelete = function (options) {
        var _this = this;
        return (0, exports.NotifsApiFp)(this.configuration).deleteMeApiV1NotifsMeDelete(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a notif.
     * @summary Delete Notif
     * @param {string} notifId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotifsApi
     */
    NotifsApi.prototype.deleteNotifApiV1NotifsNotifIdDelete = function (notifId, options) {
        var _this = this;
        return (0, exports.NotifsApiFp)(this.configuration).deleteNotifApiV1NotifsNotifIdDelete(notifId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user.
     * @summary Read Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotifsApi
     */
    NotifsApi.prototype.readMeApiV1NotifsMeGet = function (options) {
        var _this = this;
        return (0, exports.NotifsApiFp)(this.configuration).readMeApiV1NotifsMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NotifsApi;
}(base_1.BaseAPI));
exports.NotifsApi = NotifsApi;
/**
 * OrgsApi - axios parameter creator
 * @export
 */
var OrgsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get Org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgApiV1OrgsMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/orgs/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Org Cases
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgCasesApiV1OrgsMeCasesGet: function (skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([skip_1, limit_1], args_1, true), void 0, function (skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/orgs/me/cases";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrgsApiAxiosParamCreator = OrgsApiAxiosParamCreator;
/**
 * OrgsApi - functional programming interface
 * @export
 */
var OrgsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrgsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgApiV1OrgsMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrgApiV1OrgsMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrgsApi.getOrgApiV1OrgsMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Org Cases
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgCasesApiV1OrgsMeCasesGet: function (skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrgCasesApiV1OrgsMeCasesGet(skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrgsApi.getOrgCasesApiV1OrgsMeCasesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OrgsApiFp = OrgsApiFp;
/**
 * OrgsApi - factory interface
 * @export
 */
var OrgsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrgsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgApiV1OrgsMeGet: function (options) {
            return localVarFp.getOrgApiV1OrgsMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Org Cases
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgCasesApiV1OrgsMeCasesGet: function (skip, limit, options) {
            return localVarFp.getOrgCasesApiV1OrgsMeCasesGet(skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrgsApiFactory = OrgsApiFactory;
/**
 * OrgsApi - object-oriented interface
 * @export
 * @class OrgsApi
 * @extends {BaseAPI}
 */
var OrgsApi = /** @class */ (function (_super) {
    __extends(OrgsApi, _super);
    function OrgsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get Org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    OrgsApi.prototype.getOrgApiV1OrgsMeGet = function (options) {
        var _this = this;
        return (0, exports.OrgsApiFp)(this.configuration).getOrgApiV1OrgsMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Org Cases
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    OrgsApi.prototype.getOrgCasesApiV1OrgsMeCasesGet = function (skip, limit, options) {
        var _this = this;
        return (0, exports.OrgsApiFp)(this.configuration).getOrgCasesApiV1OrgsMeCasesGet(skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrgsApi;
}(base_1.BaseAPI));
exports.OrgsApi = OrgsApi;
/**
 * OverridesApi - axios parameter creator
 * @export
 */
var OverridesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Read Salesforce Entities
         * @param {string} instanceUrl
         * @param {SalesforceObjectType} sObjectType
         * @param {string} cols
         * @param {string} query
         * @param {string | null} [recordType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSalesforceEntitiesApiV1OverridesSalesforceQueryGet: function (instanceUrl_1, sObjectType_1, cols_1, query_1, recordType_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([instanceUrl_1, sObjectType_1, cols_1, query_1, recordType_1], args_1, true), void 0, function (instanceUrl, sObjectType, cols, query, recordType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'instanceUrl' is not null or undefined
                            (0, common_1.assertParamExists)('readSalesforceEntitiesApiV1OverridesSalesforceQueryGet', 'instanceUrl', instanceUrl);
                            // verify required parameter 'sObjectType' is not null or undefined
                            (0, common_1.assertParamExists)('readSalesforceEntitiesApiV1OverridesSalesforceQueryGet', 'sObjectType', sObjectType);
                            // verify required parameter 'cols' is not null or undefined
                            (0, common_1.assertParamExists)('readSalesforceEntitiesApiV1OverridesSalesforceQueryGet', 'cols', cols);
                            // verify required parameter 'query' is not null or undefined
                            (0, common_1.assertParamExists)('readSalesforceEntitiesApiV1OverridesSalesforceQueryGet', 'query', query);
                            localVarPath = "/api/v1/overrides/salesforce/query";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (instanceUrl !== undefined) {
                                localVarQueryParameter['instance_url'] = instanceUrl;
                            }
                            if (sObjectType !== undefined) {
                                localVarQueryParameter['s_object_type'] = sObjectType;
                            }
                            if (cols !== undefined) {
                                localVarQueryParameter['cols'] = cols;
                            }
                            if (query !== undefined) {
                                localVarQueryParameter['query'] = query;
                            }
                            if (recordType !== undefined) {
                                localVarQueryParameter['record_type'] = recordType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OverridesApiAxiosParamCreator = OverridesApiAxiosParamCreator;
/**
 * OverridesApi - functional programming interface
 * @export
 */
var OverridesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OverridesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Read Salesforce Entities
         * @param {string} instanceUrl
         * @param {SalesforceObjectType} sObjectType
         * @param {string} cols
         * @param {string} query
         * @param {string | null} [recordType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSalesforceEntitiesApiV1OverridesSalesforceQueryGet: function (instanceUrl, sObjectType, cols, query, recordType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readSalesforceEntitiesApiV1OverridesSalesforceQueryGet(instanceUrl, sObjectType, cols, query, recordType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OverridesApi.readSalesforceEntitiesApiV1OverridesSalesforceQueryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OverridesApiFp = OverridesApiFp;
/**
 * OverridesApi - factory interface
 * @export
 */
var OverridesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OverridesApiFp)(configuration);
    return {
        /**
         *
         * @summary Read Salesforce Entities
         * @param {string} instanceUrl
         * @param {SalesforceObjectType} sObjectType
         * @param {string} cols
         * @param {string} query
         * @param {string | null} [recordType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSalesforceEntitiesApiV1OverridesSalesforceQueryGet: function (instanceUrl, sObjectType, cols, query, recordType, options) {
            return localVarFp.readSalesforceEntitiesApiV1OverridesSalesforceQueryGet(instanceUrl, sObjectType, cols, query, recordType, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OverridesApiFactory = OverridesApiFactory;
/**
 * OverridesApi - object-oriented interface
 * @export
 * @class OverridesApi
 * @extends {BaseAPI}
 */
var OverridesApi = /** @class */ (function (_super) {
    __extends(OverridesApi, _super);
    function OverridesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Read Salesforce Entities
     * @param {string} instanceUrl
     * @param {SalesforceObjectType} sObjectType
     * @param {string} cols
     * @param {string} query
     * @param {string | null} [recordType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverridesApi
     */
    OverridesApi.prototype.readSalesforceEntitiesApiV1OverridesSalesforceQueryGet = function (instanceUrl, sObjectType, cols, query, recordType, options) {
        var _this = this;
        return (0, exports.OverridesApiFp)(this.configuration).readSalesforceEntitiesApiV1OverridesSalesforceQueryGet(instanceUrl, sObjectType, cols, query, recordType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OverridesApi;
}(base_1.BaseAPI));
exports.OverridesApi = OverridesApi;
/**
 * PingApi - axios parameter creator
 * @export
 */
var PingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingApiV1AdminPingGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/ping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PingApiAxiosParamCreator = PingApiAxiosParamCreator;
/**
 * PingApi - functional programming interface
 * @export
 */
var PingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingApiV1AdminPingGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pingApiV1AdminPingGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PingApi.pingApiV1AdminPingGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PingApiFp = PingApiFp;
/**
 * PingApi - factory interface
 * @export
 */
var PingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PingApiFp)(configuration);
    return {
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingApiV1AdminPingGet: function (options) {
            return localVarFp.pingApiV1AdminPingGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PingApiFactory = PingApiFactory;
/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
var PingApi = /** @class */ (function (_super) {
    __extends(PingApi, _super);
    function PingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    PingApi.prototype.pingApiV1AdminPingGet = function (options) {
        var _this = this;
        return (0, exports.PingApiFp)(this.configuration).pingApiV1AdminPingGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PingApi;
}(base_1.BaseAPI));
exports.PingApi = PingApi;
/**
 * RunsApi - axios parameter creator
 * @export
 */
var RunsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRunApiV1RunsRunIdDelete: function (runId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1], args_1, true), void 0, function (runId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'runId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRunApiV1RunsRunIdDelete', 'runId', runId);
                            localVarPath = "/api/v1/runs/{run_id}"
                                .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Execute Again Run
         * @param {string} runId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAgainRunApiV1RunsRunIdPost: function (runId_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1, body_1], args_1, true), void 0, function (runId, body, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'runId' is not null or undefined
                            (0, common_1.assertParamExists)('executeAgainRunApiV1RunsRunIdPost', 'runId', runId);
                            // verify required parameter 'body' is not null or undefined
                            (0, common_1.assertParamExists)('executeAgainRunApiV1RunsRunIdPost', 'body', body);
                            localVarPath = "/api/v1/runs/{run_id}"
                                .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate Pdf
         * @param {string} html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfApiV1RunsPdfPost: function (html_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([html_1], args_1, true), void 0, function (html, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'html' is not null or undefined
                    (0, common_1.assertParamExists)('generatePdfApiV1RunsPdfPost', 'html', html);
                    localVarPath = "/api/v1/runs/pdf";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (html !== undefined) {
                        localVarFormParams.set('html', html);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Read Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunApiV1RunsRunIdGet: function (runId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1], args_1, true), void 0, function (runId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'runId' is not null or undefined
                            (0, common_1.assertParamExists)('readRunApiV1RunsRunIdGet', 'runId', runId);
                            localVarPath = "/api/v1/runs/{run_id}"
                                .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Run With Flow
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunWithFlowApiV1RunsRunIdDetailsGet: function (runId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1], args_1, true), void 0, function (runId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'runId' is not null or undefined
                            (0, common_1.assertParamExists)('readRunWithFlowApiV1RunsRunIdDetailsGet', 'runId', runId);
                            localVarPath = "/api/v1/runs/{run_id}/details"
                                .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Runs
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunsApiV1RunsMeGet: function (skip_1, limit_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([skip_1, limit_1], args_1, true), void 0, function (skip, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/runs/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Output
         * @param {string} runId
         * @param {string} key
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutputApiV1RunsRunIdOutputKeyPut: function (runId_1, key_1, body_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([runId_1, key_1, body_1], args_1, true), void 0, function (runId, key, body, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'runId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOutputApiV1RunsRunIdOutputKeyPut', 'runId', runId);
                            // verify required parameter 'key' is not null or undefined
                            (0, common_1.assertParamExists)('updateOutputApiV1RunsRunIdOutputKeyPut', 'key', key);
                            // verify required parameter 'body' is not null or undefined
                            (0, common_1.assertParamExists)('updateOutputApiV1RunsRunIdOutputKeyPut', 'body', body);
                            localVarPath = "/api/v1/runs/{run_id}/output/{key}"
                                .replace("{".concat("run_id", "}"), encodeURIComponent(String(runId)))
                                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RunsApiAxiosParamCreator = RunsApiAxiosParamCreator;
/**
 * RunsApi - functional programming interface
 * @export
 */
var RunsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RunsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRunApiV1RunsRunIdDelete: function (runId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRunApiV1RunsRunIdDelete(runId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RunsApi.deleteRunApiV1RunsRunIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Execute Again Run
         * @param {string} runId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAgainRunApiV1RunsRunIdPost: function (runId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.executeAgainRunApiV1RunsRunIdPost(runId, body, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RunsApi.executeAgainRunApiV1RunsRunIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate Pdf
         * @param {string} html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfApiV1RunsPdfPost: function (html, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generatePdfApiV1RunsPdfPost(html, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RunsApi.generatePdfApiV1RunsPdfPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunApiV1RunsRunIdGet: function (runId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readRunApiV1RunsRunIdGet(runId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RunsApi.readRunApiV1RunsRunIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Run With Flow
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunWithFlowApiV1RunsRunIdDetailsGet: function (runId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readRunWithFlowApiV1RunsRunIdDetailsGet(runId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RunsApi.readRunWithFlowApiV1RunsRunIdDetailsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Runs
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunsApiV1RunsMeGet: function (skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readRunsApiV1RunsMeGet(skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RunsApi.readRunsApiV1RunsMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Output
         * @param {string} runId
         * @param {string} key
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutputApiV1RunsRunIdOutputKeyPut: function (runId, key, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOutputApiV1RunsRunIdOutputKeyPut(runId, key, body, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RunsApi.updateOutputApiV1RunsRunIdOutputKeyPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RunsApiFp = RunsApiFp;
/**
 * RunsApi - factory interface
 * @export
 */
var RunsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RunsApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRunApiV1RunsRunIdDelete: function (runId, options) {
            return localVarFp.deleteRunApiV1RunsRunIdDelete(runId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Execute Again Run
         * @param {string} runId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAgainRunApiV1RunsRunIdPost: function (runId, body, options) {
            return localVarFp.executeAgainRunApiV1RunsRunIdPost(runId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate Pdf
         * @param {string} html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfApiV1RunsPdfPost: function (html, options) {
            return localVarFp.generatePdfApiV1RunsPdfPost(html, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunApiV1RunsRunIdGet: function (runId, options) {
            return localVarFp.readRunApiV1RunsRunIdGet(runId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Run With Flow
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunWithFlowApiV1RunsRunIdDetailsGet: function (runId, options) {
            return localVarFp.readRunWithFlowApiV1RunsRunIdDetailsGet(runId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Runs
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRunsApiV1RunsMeGet: function (skip, limit, options) {
            return localVarFp.readRunsApiV1RunsMeGet(skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Output
         * @param {string} runId
         * @param {string} key
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutputApiV1RunsRunIdOutputKeyPut: function (runId, key, body, options) {
            return localVarFp.updateOutputApiV1RunsRunIdOutputKeyPut(runId, key, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RunsApiFactory = RunsApiFactory;
/**
 * RunsApi - object-oriented interface
 * @export
 * @class RunsApi
 * @extends {BaseAPI}
 */
var RunsApi = /** @class */ (function (_super) {
    __extends(RunsApi, _super);
    function RunsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete Run
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.deleteRunApiV1RunsRunIdDelete = function (runId, options) {
        var _this = this;
        return (0, exports.RunsApiFp)(this.configuration).deleteRunApiV1RunsRunIdDelete(runId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Execute Again Run
     * @param {string} runId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.executeAgainRunApiV1RunsRunIdPost = function (runId, body, options) {
        var _this = this;
        return (0, exports.RunsApiFp)(this.configuration).executeAgainRunApiV1RunsRunIdPost(runId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate Pdf
     * @param {string} html
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.generatePdfApiV1RunsPdfPost = function (html, options) {
        var _this = this;
        return (0, exports.RunsApiFp)(this.configuration).generatePdfApiV1RunsPdfPost(html, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Run
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.readRunApiV1RunsRunIdGet = function (runId, options) {
        var _this = this;
        return (0, exports.RunsApiFp)(this.configuration).readRunApiV1RunsRunIdGet(runId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Run With Flow
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.readRunWithFlowApiV1RunsRunIdDetailsGet = function (runId, options) {
        var _this = this;
        return (0, exports.RunsApiFp)(this.configuration).readRunWithFlowApiV1RunsRunIdDetailsGet(runId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Runs
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.readRunsApiV1RunsMeGet = function (skip, limit, options) {
        var _this = this;
        return (0, exports.RunsApiFp)(this.configuration).readRunsApiV1RunsMeGet(skip, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Output
     * @param {string} runId
     * @param {string} key
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    RunsApi.prototype.updateOutputApiV1RunsRunIdOutputKeyPut = function (runId, key, body, options) {
        var _this = this;
        return (0, exports.RunsApiFp)(this.configuration).updateOutputApiV1RunsRunIdOutputKeyPut(runId, key, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RunsApi;
}(base_1.BaseAPI));
exports.RunsApi = RunsApi;
/**
 * SentryApi - axios parameter creator
 * @export
 */
var SentryApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Test Sentry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSentryApiV1AdminSentryGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/admin/sentry";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SentryApiAxiosParamCreator = SentryApiAxiosParamCreator;
/**
 * SentryApi - functional programming interface
 * @export
 */
var SentryApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SentryApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Test Sentry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSentryApiV1AdminSentryGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.testSentryApiV1AdminSentryGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SentryApi.testSentryApiV1AdminSentryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SentryApiFp = SentryApiFp;
/**
 * SentryApi - factory interface
 * @export
 */
var SentryApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SentryApiFp)(configuration);
    return {
        /**
         *
         * @summary Test Sentry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSentryApiV1AdminSentryGet: function (options) {
            return localVarFp.testSentryApiV1AdminSentryGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SentryApiFactory = SentryApiFactory;
/**
 * SentryApi - object-oriented interface
 * @export
 * @class SentryApi
 * @extends {BaseAPI}
 */
var SentryApi = /** @class */ (function (_super) {
    __extends(SentryApi, _super);
    function SentryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Test Sentry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SentryApi
     */
    SentryApi.prototype.testSentryApiV1AdminSentryGet = function (options) {
        var _this = this;
        return (0, exports.SentryApiFp)(this.configuration).testSentryApiV1AdminSentryGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SentryApi;
}(base_1.BaseAPI));
exports.SentryApi = SentryApi;
/**
 * StripeApi - axios parameter creator
 * @export
 */
var StripeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Stripe Webhook
         * @param {any} [stripeSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhookApiV1StripeWebhookPost: function (stripeSignature_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([stripeSignature_1], args_1, true), void 0, function (stripeSignature, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/stripe/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (stripeSignature != null) {
                        localVarHeaderParameter['stripe-signature'] = typeof stripeSignature === 'string'
                            ? stripeSignature
                            : JSON.stringify(stripeSignature);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.StripeApiAxiosParamCreator = StripeApiAxiosParamCreator;
/**
 * StripeApi - functional programming interface
 * @export
 */
var StripeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StripeApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Stripe Webhook
         * @param {any} [stripeSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhookApiV1StripeWebhookPost: function (stripeSignature, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stripeWebhookApiV1StripeWebhookPost(stripeSignature, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StripeApi.stripeWebhookApiV1StripeWebhookPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.StripeApiFp = StripeApiFp;
/**
 * StripeApi - factory interface
 * @export
 */
var StripeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StripeApiFp)(configuration);
    return {
        /**
         *
         * @summary Stripe Webhook
         * @param {any} [stripeSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhookApiV1StripeWebhookPost: function (stripeSignature, options) {
            return localVarFp.stripeWebhookApiV1StripeWebhookPost(stripeSignature, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StripeApiFactory = StripeApiFactory;
/**
 * StripeApi - object-oriented interface
 * @export
 * @class StripeApi
 * @extends {BaseAPI}
 */
var StripeApi = /** @class */ (function (_super) {
    __extends(StripeApi, _super);
    function StripeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Stripe Webhook
     * @param {any} [stripeSignature]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.stripeWebhookApiV1StripeWebhookPost = function (stripeSignature, options) {
        var _this = this;
        return (0, exports.StripeApiFp)(this.configuration).stripeWebhookApiV1StripeWebhookPost(stripeSignature, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StripeApi;
}(base_1.BaseAPI));
exports.StripeApi = StripeApi;
/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
var SubscriptionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Long polling for checking that token properly added
         * @summary Check Subscription
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubscriptionApiV1SubscriptionsCheckRefGet: function (ref_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ref_1], args_1, true), void 0, function (ref, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ref' is not null or undefined
                            (0, common_1.assertParamExists)('checkSubscriptionApiV1SubscriptionsCheckRefGet', 'ref', ref);
                            localVarPath = "/api/v1/subscriptions/check/{ref}"
                                .replace("{".concat("ref", "}"), encodeURIComponent(String(ref)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Checkout
         * @param {string} plan
         * @param {string} successUrl
         * @param {string} cancelUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutApiV1SubscriptionsCheckoutGet: function (plan_1, successUrl_1, cancelUrl_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([plan_1, successUrl_1, cancelUrl_1], args_1, true), void 0, function (plan, successUrl, cancelUrl, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'plan' is not null or undefined
                            (0, common_1.assertParamExists)('checkoutApiV1SubscriptionsCheckoutGet', 'plan', plan);
                            // verify required parameter 'successUrl' is not null or undefined
                            (0, common_1.assertParamExists)('checkoutApiV1SubscriptionsCheckoutGet', 'successUrl', successUrl);
                            // verify required parameter 'cancelUrl' is not null or undefined
                            (0, common_1.assertParamExists)('checkoutApiV1SubscriptionsCheckoutGet', 'cancelUrl', cancelUrl);
                            localVarPath = "/api/v1/subscriptions/checkout";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (plan !== undefined) {
                                localVarQueryParameter['plan'] = plan;
                            }
                            if (successUrl !== undefined) {
                                localVarQueryParameter['success_url'] = successUrl;
                            }
                            if (cancelUrl !== undefined) {
                                localVarQueryParameter['cancel_url'] = cancelUrl;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionApiV1SubscriptionsSubscriptionIdGet: function (subscriptionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([subscriptionId_1], args_1, true), void 0, function (subscriptionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'subscriptionId' is not null or undefined
                            (0, common_1.assertParamExists)('readSubscriptionApiV1SubscriptionsSubscriptionIdGet', 'subscriptionId', subscriptionId);
                            localVarPath = "/api/v1/subscriptions/{subscription_id}"
                                .replace("{".concat("subscription_id", "}"), encodeURIComponent(String(subscriptionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionsApiV1SubscriptionsMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/subscriptions/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SubscriptionsApiAxiosParamCreator = SubscriptionsApiAxiosParamCreator;
/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
var SubscriptionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubscriptionsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Long polling for checking that token properly added
         * @summary Check Subscription
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubscriptionApiV1SubscriptionsCheckRefGet: function (ref, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkSubscriptionApiV1SubscriptionsCheckRefGet(ref, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubscriptionsApi.checkSubscriptionApiV1SubscriptionsCheckRefGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Checkout
         * @param {string} plan
         * @param {string} successUrl
         * @param {string} cancelUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutApiV1SubscriptionsCheckoutGet: function (plan, successUrl, cancelUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkoutApiV1SubscriptionsCheckoutGet(plan, successUrl, cancelUrl, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubscriptionsApi.checkoutApiV1SubscriptionsCheckoutGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionApiV1SubscriptionsSubscriptionIdGet: function (subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readSubscriptionApiV1SubscriptionsSubscriptionIdGet(subscriptionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubscriptionsApi.readSubscriptionApiV1SubscriptionsSubscriptionIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Read Subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionsApiV1SubscriptionsMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readSubscriptionsApiV1SubscriptionsMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubscriptionsApi.readSubscriptionsApiV1SubscriptionsMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SubscriptionsApiFp = SubscriptionsApiFp;
/**
 * SubscriptionsApi - factory interface
 * @export
 */
var SubscriptionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubscriptionsApiFp)(configuration);
    return {
        /**
         * Long polling for checking that token properly added
         * @summary Check Subscription
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubscriptionApiV1SubscriptionsCheckRefGet: function (ref, options) {
            return localVarFp.checkSubscriptionApiV1SubscriptionsCheckRefGet(ref, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Checkout
         * @param {string} plan
         * @param {string} successUrl
         * @param {string} cancelUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutApiV1SubscriptionsCheckoutGet: function (plan, successUrl, cancelUrl, options) {
            return localVarFp.checkoutApiV1SubscriptionsCheckoutGet(plan, successUrl, cancelUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionApiV1SubscriptionsSubscriptionIdGet: function (subscriptionId, options) {
            return localVarFp.readSubscriptionApiV1SubscriptionsSubscriptionIdGet(subscriptionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Read Subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSubscriptionsApiV1SubscriptionsMeGet: function (options) {
            return localVarFp.readSubscriptionsApiV1SubscriptionsMeGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubscriptionsApiFactory = SubscriptionsApiFactory;
/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
var SubscriptionsApi = /** @class */ (function (_super) {
    __extends(SubscriptionsApi, _super);
    function SubscriptionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Long polling for checking that token properly added
     * @summary Check Subscription
     * @param {string} ref
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    SubscriptionsApi.prototype.checkSubscriptionApiV1SubscriptionsCheckRefGet = function (ref, options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration).checkSubscriptionApiV1SubscriptionsCheckRefGet(ref, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Checkout
     * @param {string} plan
     * @param {string} successUrl
     * @param {string} cancelUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    SubscriptionsApi.prototype.checkoutApiV1SubscriptionsCheckoutGet = function (plan, successUrl, cancelUrl, options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration).checkoutApiV1SubscriptionsCheckoutGet(plan, successUrl, cancelUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Subscription
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    SubscriptionsApi.prototype.readSubscriptionApiV1SubscriptionsSubscriptionIdGet = function (subscriptionId, options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration).readSubscriptionApiV1SubscriptionsSubscriptionIdGet(subscriptionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Read Subscriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    SubscriptionsApi.prototype.readSubscriptionsApiV1SubscriptionsMeGet = function (options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration).readSubscriptionsApiV1SubscriptionsMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubscriptionsApi;
}(base_1.BaseAPI));
exports.SubscriptionsApi = SubscriptionsApi;
/**
 * TemplatesApi - axios parameter creator
 * @export
 */
var TemplatesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create flow from template.
         * @summary Create Flow From Template
         * @param {string} templateId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost: function (templateId_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1, body_1], args_1, true), void 0, function (templateId, body, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost', 'templateId', templateId);
                            // verify required parameter 'body' is not null or undefined
                            (0, common_1.assertParamExists)('createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost', 'body', body);
                            localVarPath = "/api/v1/templates/{template_id}/flows"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create all necessary Google Sheets for the template, and prefill the sheets & headers
         * @summary Create Template With Gsheets
         * @param {string} templateId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost: function (templateId_1, redirectUrl_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1, redirectUrl_1], args_1, true), void 0, function (templateId, redirectUrl, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost', 'templateId', templateId);
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost', 'redirectUrl', redirectUrl);
                            localVarPath = "/api/v1/templates/{template_id}/sheets"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This was created quickly for expo. It\'s a bit of a mess. Delete it when you can.
         * @summary Create Template With Gsheets Expo
         * @param {string} templateId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost: function (templateId_1, redirectUrl_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1, redirectUrl_1], args_1, true), void 0, function (templateId, redirectUrl, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost', 'templateId', templateId);
                            // verify required parameter 'redirectUrl' is not null or undefined
                            (0, common_1.assertParamExists)('createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost', 'redirectUrl', redirectUrl);
                            localVarPath = "/api/v1/templates/{template_id}/sheets/expo"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete template.
         * @summary Delete Template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateApiV1TemplatesTemplateIdDelete: function (templateId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1], args_1, true), void 0, function (templateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTemplateApiV1TemplatesTemplateIdDelete', 'templateId', templateId);
                            localVarPath = "/api/v1/templates/{template_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the form with missing values for the template.
         * @summary Get Template Form
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFormApiV1TemplatesTemplateIdFormGet: function (templateId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1], args_1, true), void 0, function (templateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'templateId' is not null or undefined
                    (0, common_1.assertParamExists)('getTemplateFormApiV1TemplatesTemplateIdFormGet', 'templateId', templateId);
                    localVarPath = "/api/v1/templates/{template_id}/form"
                        .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get current user\'s templates.
         * @summary Read My Templates
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMyTemplatesApiV1TemplatesMeGet: function (limit_1, skip_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, skip_1], args_1, true), void 0, function (limit, skip, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/templates/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get template.
         * @summary Read Template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplateApiV1TemplatesTemplateIdGet: function (templateId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1], args_1, true), void 0, function (templateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'templateId' is not null or undefined
                    (0, common_1.assertParamExists)('readTemplateApiV1TemplatesTemplateIdGet', 'templateId', templateId);
                    localVarPath = "/api/v1/templates/{template_id}"
                        .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get current user\'s templates.
         * @summary Read Templates
         * @param {string} [ownerId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplatesApiV1TemplatesGet: function (ownerId_1, limit_1, skip_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ownerId_1, limit_1, skip_1], args_1, true), void 0, function (ownerId, limit, skip, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/templates";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ownerId !== undefined) {
                        localVarQueryParameter['owner_id'] = ownerId;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update template.
         * @summary Update Template
         * @param {string} templateId
         * @param {TemplateUpdate} templateUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateApiV1TemplatesTemplateIdPut: function (templateId_1, templateUpdate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([templateId_1, templateUpdate_1], args_1, true), void 0, function (templateId, templateUpdate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTemplateApiV1TemplatesTemplateIdPut', 'templateId', templateId);
                            // verify required parameter 'templateUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateTemplateApiV1TemplatesTemplateIdPut', 'templateUpdate', templateUpdate);
                            localVarPath = "/api/v1/templates/{template_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(templateUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TemplatesApiAxiosParamCreator = TemplatesApiAxiosParamCreator;
/**
 * TemplatesApi - functional programming interface
 * @export
 */
var TemplatesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TemplatesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create flow from template.
         * @summary Create Flow From Template
         * @param {string} templateId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost: function (templateId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost(templateId, body, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create all necessary Google Sheets for the template, and prefill the sheets & headers
         * @summary Create Template With Gsheets
         * @param {string} templateId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost: function (templateId, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost(templateId, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This was created quickly for expo. It\'s a bit of a mess. Delete it when you can.
         * @summary Create Template With Gsheets Expo
         * @param {string} templateId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost: function (templateId, redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost(templateId, redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete template.
         * @summary Delete Template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateApiV1TemplatesTemplateIdDelete: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTemplateApiV1TemplatesTemplateIdDelete(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.deleteTemplateApiV1TemplatesTemplateIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns the form with missing values for the template.
         * @summary Get Template Form
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFormApiV1TemplatesTemplateIdFormGet: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTemplateFormApiV1TemplatesTemplateIdFormGet(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.getTemplateFormApiV1TemplatesTemplateIdFormGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user\'s templates.
         * @summary Read My Templates
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMyTemplatesApiV1TemplatesMeGet: function (limit, skip, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readMyTemplatesApiV1TemplatesMeGet(limit, skip, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.readMyTemplatesApiV1TemplatesMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get template.
         * @summary Read Template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplateApiV1TemplatesTemplateIdGet: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readTemplateApiV1TemplatesTemplateIdGet(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.readTemplateApiV1TemplatesTemplateIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user\'s templates.
         * @summary Read Templates
         * @param {string} [ownerId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplatesApiV1TemplatesGet: function (ownerId, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readTemplatesApiV1TemplatesGet(ownerId, limit, skip, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.readTemplatesApiV1TemplatesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update template.
         * @summary Update Template
         * @param {string} templateId
         * @param {TemplateUpdate} templateUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateApiV1TemplatesTemplateIdPut: function (templateId, templateUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTemplateApiV1TemplatesTemplateIdPut(templateId, templateUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplatesApi.updateTemplateApiV1TemplatesTemplateIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.TemplatesApiFp = TemplatesApiFp;
/**
 * TemplatesApi - factory interface
 * @export
 */
var TemplatesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TemplatesApiFp)(configuration);
    return {
        /**
         * Create flow from template.
         * @summary Create Flow From Template
         * @param {string} templateId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost: function (templateId, body, options) {
            return localVarFp.createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost(templateId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create all necessary Google Sheets for the template, and prefill the sheets & headers
         * @summary Create Template With Gsheets
         * @param {string} templateId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost: function (templateId, redirectUrl, options) {
            return localVarFp.createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost(templateId, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This was created quickly for expo. It\'s a bit of a mess. Delete it when you can.
         * @summary Create Template With Gsheets Expo
         * @param {string} templateId
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost: function (templateId, redirectUrl, options) {
            return localVarFp.createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost(templateId, redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete template.
         * @summary Delete Template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateApiV1TemplatesTemplateIdDelete: function (templateId, options) {
            return localVarFp.deleteTemplateApiV1TemplatesTemplateIdDelete(templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the form with missing values for the template.
         * @summary Get Template Form
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFormApiV1TemplatesTemplateIdFormGet: function (templateId, options) {
            return localVarFp.getTemplateFormApiV1TemplatesTemplateIdFormGet(templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user\'s templates.
         * @summary Read My Templates
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMyTemplatesApiV1TemplatesMeGet: function (limit, skip, options) {
            return localVarFp.readMyTemplatesApiV1TemplatesMeGet(limit, skip, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get template.
         * @summary Read Template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplateApiV1TemplatesTemplateIdGet: function (templateId, options) {
            return localVarFp.readTemplateApiV1TemplatesTemplateIdGet(templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user\'s templates.
         * @summary Read Templates
         * @param {string} [ownerId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTemplatesApiV1TemplatesGet: function (ownerId, limit, skip, options) {
            return localVarFp.readTemplatesApiV1TemplatesGet(ownerId, limit, skip, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update template.
         * @summary Update Template
         * @param {string} templateId
         * @param {TemplateUpdate} templateUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateApiV1TemplatesTemplateIdPut: function (templateId, templateUpdate, options) {
            return localVarFp.updateTemplateApiV1TemplatesTemplateIdPut(templateId, templateUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TemplatesApiFactory = TemplatesApiFactory;
/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
var TemplatesApi = /** @class */ (function (_super) {
    __extends(TemplatesApi, _super);
    function TemplatesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create flow from template.
     * @summary Create Flow From Template
     * @param {string} templateId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost = function (templateId, body, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).createFlowFromTemplateApiV1TemplatesTemplateIdFlowsPost(templateId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create all necessary Google Sheets for the template, and prefill the sheets & headers
     * @summary Create Template With Gsheets
     * @param {string} templateId
     * @param {string} redirectUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost = function (templateId, redirectUrl, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).createTemplateWithGsheetsApiV1TemplatesTemplateIdSheetsPost(templateId, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This was created quickly for expo. It\'s a bit of a mess. Delete it when you can.
     * @summary Create Template With Gsheets Expo
     * @param {string} templateId
     * @param {string} redirectUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost = function (templateId, redirectUrl, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).createTemplateWithGsheetsExpoApiV1TemplatesTemplateIdSheetsExpoPost(templateId, redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete template.
     * @summary Delete Template
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.deleteTemplateApiV1TemplatesTemplateIdDelete = function (templateId, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).deleteTemplateApiV1TemplatesTemplateIdDelete(templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the form with missing values for the template.
     * @summary Get Template Form
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.getTemplateFormApiV1TemplatesTemplateIdFormGet = function (templateId, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).getTemplateFormApiV1TemplatesTemplateIdFormGet(templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user\'s templates.
     * @summary Read My Templates
     * @param {number} [limit]
     * @param {number} [skip]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.readMyTemplatesApiV1TemplatesMeGet = function (limit, skip, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).readMyTemplatesApiV1TemplatesMeGet(limit, skip, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get template.
     * @summary Read Template
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.readTemplateApiV1TemplatesTemplateIdGet = function (templateId, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).readTemplateApiV1TemplatesTemplateIdGet(templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user\'s templates.
     * @summary Read Templates
     * @param {string} [ownerId]
     * @param {number} [limit]
     * @param {number} [skip]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.readTemplatesApiV1TemplatesGet = function (ownerId, limit, skip, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).readTemplatesApiV1TemplatesGet(ownerId, limit, skip, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update template.
     * @summary Update Template
     * @param {string} templateId
     * @param {TemplateUpdate} templateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    TemplatesApi.prototype.updateTemplateApiV1TemplatesTemplateIdPut = function (templateId, templateUpdate, options) {
        var _this = this;
        return (0, exports.TemplatesApiFp)(this.configuration).updateTemplateApiV1TemplatesTemplateIdPut(templateId, templateUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TemplatesApi;
}(base_1.BaseAPI));
exports.TemplatesApi = TemplatesApi;
/**
 * UsersApi - axios parameter creator
 * @export
 */
var UsersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create API key.
         * @summary Add Env Var
         * @param {EnvVariableCreate} envVariableCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEnvVarApiV1UsersMeEnvVarsPost: function (envVariableCreate_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([envVariableCreate_1], args_1, true), void 0, function (envVariableCreate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'envVariableCreate' is not null or undefined
                            (0, common_1.assertParamExists)('addEnvVarApiV1UsersMeEnvVarsPost', 'envVariableCreate', envVariableCreate);
                            localVarPath = "/api/v1/users/me/env-vars";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(envVariableCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete API key.
         * @summary Delete Env Var
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete: function (envVarId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([envVarId_1], args_1, true), void 0, function (envVarId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'envVarId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete', 'envVarId', envVarId);
                            localVarPath = "/api/v1/users/me/env-vars/{env_var_id}"
                                .replace("{".concat("env_var_id", "}"), encodeURIComponent(String(envVarId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Quick join a user.
         * @summary Join User
         * @param {UserJoin} userJoin
         * @param {string} [acceptLanguage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinUserApiV1UsersJoinPost: function (userJoin_1, acceptLanguage_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userJoin_1, acceptLanguage_1], args_1, true), void 0, function (userJoin, acceptLanguage, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userJoin' is not null or undefined
                    (0, common_1.assertParamExists)('joinUserApiV1UsersJoinPost', 'userJoin', userJoin);
                    localVarPath = "/api/v1/users/join";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['accept-language'] = String(acceptLanguage);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userJoin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get env vars.
         * @summary Read Env Vars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEnvVarsApiV1UsersMeEnvVarsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/users/me/env-vars";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get current user.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1UsersMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/users/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update API key.
         * @summary Update Env Var
         * @param {string} envVarId
         * @param {EnvVariableUpdate} envVariableUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut: function (envVarId_1, envVariableUpdate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([envVarId_1, envVariableUpdate_1], args_1, true), void 0, function (envVarId, envVariableUpdate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'envVarId' is not null or undefined
                            (0, common_1.assertParamExists)('updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut', 'envVarId', envVarId);
                            // verify required parameter 'envVariableUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut', 'envVariableUpdate', envVariableUpdate);
                            localVarPath = "/api/v1/users/me/env-vars/{env_var_id}"
                                .replace("{".concat("env_var_id", "}"), encodeURIComponent(String(envVarId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(envVariableUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UsersApiAxiosParamCreator = UsersApiAxiosParamCreator;
/**
 * UsersApi - functional programming interface
 * @export
 */
var UsersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UsersApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create API key.
         * @summary Add Env Var
         * @param {EnvVariableCreate} envVariableCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEnvVarApiV1UsersMeEnvVarsPost: function (envVariableCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addEnvVarApiV1UsersMeEnvVarsPost(envVariableCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.addEnvVarApiV1UsersMeEnvVarsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete API key.
         * @summary Delete Env Var
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete: function (envVarId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete(envVarId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Quick join a user.
         * @summary Join User
         * @param {UserJoin} userJoin
         * @param {string} [acceptLanguage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinUserApiV1UsersJoinPost: function (userJoin, acceptLanguage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.joinUserApiV1UsersJoinPost(userJoin, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.joinUserApiV1UsersJoinPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get env vars.
         * @summary Read Env Vars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEnvVarsApiV1UsersMeEnvVarsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readEnvVarsApiV1UsersMeEnvVarsGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.readEnvVarsApiV1UsersMeEnvVarsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get current user.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1UsersMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readMeApiV1UsersMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.readMeApiV1UsersMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update API key.
         * @summary Update Env Var
         * @param {string} envVarId
         * @param {EnvVariableUpdate} envVariableUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut: function (envVarId, envVariableUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut(envVarId, envVariableUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersApi.updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UsersApiFp = UsersApiFp;
/**
 * UsersApi - factory interface
 * @export
 */
var UsersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UsersApiFp)(configuration);
    return {
        /**
         * Create API key.
         * @summary Add Env Var
         * @param {EnvVariableCreate} envVariableCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEnvVarApiV1UsersMeEnvVarsPost: function (envVariableCreate, options) {
            return localVarFp.addEnvVarApiV1UsersMeEnvVarsPost(envVariableCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete API key.
         * @summary Delete Env Var
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete: function (envVarId, options) {
            return localVarFp.deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete(envVarId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Quick join a user.
         * @summary Join User
         * @param {UserJoin} userJoin
         * @param {string} [acceptLanguage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinUserApiV1UsersJoinPost: function (userJoin, acceptLanguage, options) {
            return localVarFp.joinUserApiV1UsersJoinPost(userJoin, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get env vars.
         * @summary Read Env Vars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEnvVarsApiV1UsersMeEnvVarsGet: function (options) {
            return localVarFp.readEnvVarsApiV1UsersMeEnvVarsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get current user.
         * @summary Read Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMeApiV1UsersMeGet: function (options) {
            return localVarFp.readMeApiV1UsersMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update API key.
         * @summary Update Env Var
         * @param {string} envVarId
         * @param {EnvVariableUpdate} envVariableUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut: function (envVarId, envVariableUpdate, options) {
            return localVarFp.updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut(envVarId, envVariableUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create API key.
     * @summary Add Env Var
     * @param {EnvVariableCreate} envVariableCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.addEnvVarApiV1UsersMeEnvVarsPost = function (envVariableCreate, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).addEnvVarApiV1UsersMeEnvVarsPost(envVariableCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete API key.
     * @summary Delete Env Var
     * @param {string} envVarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete = function (envVarId, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).deleteEnvVarApiV1UsersMeEnvVarsEnvVarIdDelete(envVarId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Quick join a user.
     * @summary Join User
     * @param {UserJoin} userJoin
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.joinUserApiV1UsersJoinPost = function (userJoin, acceptLanguage, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).joinUserApiV1UsersJoinPost(userJoin, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get env vars.
     * @summary Read Env Vars
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.readEnvVarsApiV1UsersMeEnvVarsGet = function (options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).readEnvVarsApiV1UsersMeEnvVarsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get current user.
     * @summary Read Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.readMeApiV1UsersMeGet = function (options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).readMeApiV1UsersMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update API key.
     * @summary Update Env Var
     * @param {string} envVarId
     * @param {EnvVariableUpdate} envVariableUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut = function (envVarId, envVariableUpdate, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).updateEnvVarApiV1UsersMeEnvVarsEnvVarIdPut(envVarId, envVariableUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersApi;
}(base_1.BaseAPI));
exports.UsersApi = UsersApi;
